/*!
  Machina, by Whiley Mai
  Version, 1.0.0
  machina-dev.js
  Development mode
  https://whileymai.com
*/

//strict mode enabled
'use strict';

//START - All code to execute as soon as the script loads
(function(){
  console.log('Dev Mode');
   //global functions
   let globalEvents = {
     removeDuplicateShopPay: function(){
       var divsToRemove = document.querySelectorAll(".shopify-payment-terms");
       for (var i = 0; i < 1; i++) {
         if(divsToRemove[i + 1] != null){
           divsToRemove[i + 1].remove();
         }
         // console.log(divsToRemove[i]);
       }
     },
     subscriptionsOnLoad: function(){
       let optionSellingPlan = "select[name=selling_plan] option",
           opt_subscription = document.querySelector("input[name='loop_purchase_option']");

       if(opt_subscription != null){
         if(opt_subscription.getAttribute("name") == "loop_purchase_option"){
           if(opt_subscription.getAttribute("id") == "loop-one-time-purchase" && opt_subscription.getAttribute("checked") != null){
             console.log("selling plan value", document.querySelector("select[name=selling_plan]").value);
             document.querySelectorAll(optionSellingPlan)[0].removeAttribute("disabled");
             document.querySelectorAll(optionSellingPlan)[1].removeAttribute("selected");
             document.querySelectorAll(optionSellingPlan)[0].selected = 'selected';
             console.log(document.querySelector("select[name=selling_plan]"));
             document.querySelector("select[name=selling_plan]").value ='';
           } else{
             document.querySelectorAll(optionSellingPlan)[0].removeAttribute("selected");
             document.querySelectorAll(optionSellingPlan)[1].selected = 'selected';
             document.querySelectorAll(optionSellingPlan)[0].setAttribute("disabled", "disabled");
           }
         }
       }
     },
     backToTop: function(){
      if(document.querySelector('#back-top') != null) {
        var backToTop = document.querySelector('#back-top');
        window.addEventListener('scroll', function(e) {
          if(window.scrollY > 300 ) {
              backToTop.classList.add('show');
            } else {
              backToTop.classList.remove('show');
            }
          });
          backToTop.addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
         });
       }
     },
     reviewScroll: function(){
       const btnReviews = document.querySelector('.spr-summary-starrating');
       const appReviews = document.querySelector('#shopify-product-reviews');
       //review scroll event listener
       if(appReviews != null){
         btnReviews.addEventListener('click', function(e) {
           appReviews.scrollIntoView({
             behavior: 'smooth',
             block: 'center'
           });
         });
       }
     },
     resetElements: function(){
       //reset elements of selected variant on PDP
       const resetEls = document.querySelector(".js-variant-id-image, .js-variant-radio")
       if(resetEls != null){
         resetEls.onclick = function() {
           console.log('reset elements');
           document.querySelector(".qty").value = 1;
           document.querySelector(".js-minus").setAttribute("disabled", true);
           document.querySelector(".minus").setAttribute("disabled", true);
           document.querySelector("#selling_select").value = '';
         }
       }
     },
     accordians: function() {
       const accordionItems = document.querySelectorAll('.product-accordion-item span');
       //toggle accordian function
       function toggleAccordion() {
         console.log(this);
         //this refers to .product-accordion-item span
         this.classList.toggle('active');
         this.nextElementSibling.classList.toggle('active');
       }
       //call toggle accordian function when each accordian element is clicked
       if(accordionItems != null){
         accordionItems.forEach(function(item) {
           item.addEventListener('click', toggleAccordion)
         });
       }
     },
     loadingIcon: function() {
       if(document.querySelector('.add-to-cart-button') != null) {
         var ldld = new ldLoader({ root: ".add-to-cart-button" });
         ldld.on();
       }
     },
     loadCart: function() {
       const cartSidebar = document.querySelector(".sidebar");
       const floatingMenu = document.querySelector(".js-menufloat-show")
       //sidebar
       cartSidebar.classList.remove("d-none");
       cartSidebar.classList.add("d-block");
     },
     closeAccordians: function(){
       //used on the mobile menu sidebar
       var $windowWidth = window.innerWidth;
       var $accordian = document.querySelectorAll('.col-side').forEach(item => {
         if($windowWidth < 768){
           //hide the accordians
           item.classList.remove('show');
           //otherwise show accordians
         } else if($windowWidth > 768){
           item.classList.add('show');
         }
       });
     },
     init: function(){
       globalEvents.subscriptionsOnLoad();
       globalEvents.accordians();
       globalEvents.removeDuplicateShopPay();
       globalEvents.backToTop();
       globalEvents.resetElements();
       window.addEventListener('resize load', globalEvents.closeAccordians());
       window.addEventListener('DOMContentLoaded', globalEvents.loadCart);
       //run loading icon on add to cart button click
       document.addEventListener("DOMContentLoaded", globalEvents.loadingIcon);
     }
   }
  //invoke the function
  globalEvents.init();

  //START - product options
  let
    addToCartFormSelector = '.add-to-cart-form',
    productOptionSelector = addToCartFormSelector + ' [name*=option]';//any selector with the name option in the add to cart form

  //the product object with all logical operations
  let productForm = {
    //when a product changes
    onProductOptionChanged: function(self) {
      console.log("option changed");
      console.log(self.getAttribute("name"), self.value);

      let addToCartFormSellingPlan = "select[name=selling_plan] option";
      //START - if subscription options changed
      if(self.getAttribute("name") == "loop_purchase_option"){
        if(self.getAttribute("id") == "loop-one-time-purchase" && self.getAttribute("checked") != null){
          document.querySelectorAll(addToCartFormSellingPlan)[0].removeAttribute("disabled");
          document.querySelectorAll(addToCartFormSellingPlan)[1].removeAttribute("selected");
          document.querySelectorAll(addToCartFormSellingPlan)[0].selected = 'selected';
          document.querySelector("select[name=selling_plan]").value ='';
          document.querySelector(".js-quantity-picker-pdp").classList.remove('hidden');
        } else {
          document.querySelector(".js-quantity-picker-pdp").classList.add('hidden');
          document.querySelectorAll(addToCartFormSellingPlan)[0].removeAttribute("selected");
          document.querySelectorAll(addToCartFormSellingPlan)[1].selected = 'selected';
          document.querySelectorAll(addToCartFormSellingPlan)[0].setAttribute("disabled", "disabled");
          //subscription value for sticky form
          if(document.querySelector(".js-sticky-product-selling-plan") != null){
            document.querySelector(".js-sticky-product-selling-plan").value = document.querySelectorAll(addToCartFormSellingPlan)[1].value;
          }
        }
      }
      //END - if subscription options changed

      let $form = self.closest(addToCartFormSelector),
          selectedVariant = productForm.getActiveVariant($form),
          $qtyValPlus = $form.querySelector('.js-quantity-field-pdp').value,
          quantityValue = parseInt($qtyValPlus),
          btn = $form.querySelector("button[name=add]");

      console.log(selectedVariant, "selectedVariant");

      //START - change stock display in product-form.liquid
      if(selectedVariant){
        //stock numbers
        var $variantInv = $form.querySelector('#variant-inventory');
        var $stockNumber = $form.querySelectorAll('.stock-number');
        var $variantStock = $form.querySelector('.icon--inventory');

        if(selectedVariant.inventory_management == "shopify"){
          $form.querySelector('#js-product-id').setAttribute('data-inventory-tracking', '1');
        } else if(selectedVariant.inventory_management == null && selectedVariant.available){
          $form.querySelector('#js-product-id').setAttribute('data-inventory-tracking', '1');
        }
        else {
          $form.querySelector('#js-product-id').setAttribute('data-inventory-tracking', '0');
        }
        if(selectedVariant.inventory_management == "shopify" && selectedVariant.inventory_policy != "continue" && $variantInv != null){
          if(selectedVariant.inventory_quantity > 1 && selectedVariant.available && $variantInv != null){

            $variantInv.innerHTML = `<div class="stock-message-instock"><span class="stock-number">`+ selectedVariant.inventory_quantity + `</span>&nbsp;${window.theme.inStock}</div>`;

            if($variantStock != null) {
              $variantStock.classList.add('d-block');
            }
          } else if(selectedVariant.inventory_quantity < 1 && selectedVariant.available === false && $variantInv != null){
            $variantInv.innerHTML = `<div class="stock-message-sold-out"><span class="stock-number">${window.theme.outOfStock}</span></div>`;
            if($variantStock != null) {
              $variantStock.classList.add('d-none');
            }
          }
        }
        if(selectedVariant.inventory_management == null && $variantInv != null){
          $variantInv.innerHTML = `<div class="stock-message-sold-out"><span class="stock-number">${window.theme.availability}</span></div>`;
        }
        //update hidden variant id field with selectedVariant Id
        const jsVariantid = $form.querySelectorAll(".js-variant-id"); //get the dynamic js-variant-id in the form
        const jsVariantQty = $form.querySelectorAll(".js-quantity-field-pdp"); //get the dynamic js-variant-id in the form

        jsVariantid.forEach(function(item){
          if(item != null){
            item.value = selectedVariant.id;
            if(selectedVariant.inventory_management == null && selectedVariant.available){
              item.setAttribute("data-inventory-quantity", 1);
            } else {
              item.setAttribute("data-inventory-quantity", selectedVariant.inventory_quantity);
            }
          }
        });
        jsVariantQty.forEach(function(item){
          if(item != null){
            item.value = 1;
            if (selectedVariant.inventory_management == null && selectedVariant.available) {
              item.setAttribute("max", 100000);
            } else {
               var inventorypolicySl = document.querySelector('.quantity-selector-stocks .quantity-that-has-already-been-added[data-id="'+selectedVariant.id+'"]');
               if(inventorypolicySl != null){
                  var inventorypolicy = inventorypolicySl.dataset.inventorypolicy;
                  if(inventorypolicy == 'continue'){
                   item.setAttribute("max", 100000);
                  } else {
                    item.setAttribute("max", selectedVariant.inventory_quantity);
                  }
               } else {
                  item.setAttribute("max", selectedVariant.inventory_quantity);
              }
            }
          }
        });
        // product sticky form update
        if(document.body.getAttribute("id") == "product") {
          if(document.querySelector('.sticky-form-container') != null){
            var title = selectedVariant.title;
            var price = Shopify.formatMoney(selectedVariant.price, window.theme.moneyFormat);
            var compare_at_price = Shopify.formatMoney(selectedVariant.compare_at_price, window.theme.moneyFormat);
            document.querySelector('.js-sticky-product-id').value = selectedVariant.id;
            document.querySelector('.js-sticky-price').innerHTML = `${price}`;
            document.querySelector('.js-sticky-variant').innerHTML = ` - ${title}`;
            if(document.querySelector('.js-sticky-compare-price') != null){
              if(selectedVariant.compare_at_price != null){
                document.querySelector('.js-sticky-compare-price').innerHTML = `${compare_at_price}`;
              } else {
                document.querySelector('.js-sticky-compare-price').innerHTML = '';
             }
           }
         }
        }
      }
      //END - change stock display in product-form.liquid

      //START - shop pay installment changes
      if(selectedVariant && selectedVariant != undefined){
        const productForms = document.querySelectorAll(`#product-form-installment`);
        var divs = [`#product-form-installment`];
        var visibleDivId = null;
        productForms.forEach((productForm) => {
          const inputShopPay = productForm.querySelector('input[name="shop_pay"]');
          if(productForm != null){
            inputShopPay.value = selectedVariant.id;
            inputShopPay.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
      //END - shop pay installment changes

      //START - QTY added to cart without QTY PICKER
      if(document.querySelector(".selectedVariantObject") !== null){
        //parses a JSON string, constructing the JavaScript value or object described by the string
        var selectedVariantJson = JSON.parse(document.querySelector(".selectedVariantObject").innerHTML);
        console.log('selectedVariantJson', selectedVariantJson);
        if(selectedVariant == null){
          //selectedVariant = selectedVariantJson;
        }
      }
      //END - QTY added to cart without QTY PICKER

      //initiate the validate and productSlideshows functions
      productForm.validate($form, selectedVariant, selectedVariantJson);

      //change variant image
      if(document.querySelectorAll('.single-product-details') != null){
        if(self.closest('.single-product-details') != null){
         productSlideshows.init(selectedVariant, false);
        }
      }

      //START - change pickup locations
      //in product-form.liquid
      const pickUpAvailability = document.querySelector('pickup-availability');

      //if false, break the loop via return
      if (!pickUpAvailability) return;

      //pickUpAvailability will only execute if the code before the ? exsists
      if (selectedVariant?.available) {
      //fetch the selected variant id
         pickUpAvailability.fetchAvailability(selectedVariant.id);
      //otherwise clear
      } else {
         pickUpAvailability.removeAttribute('available');
         pickUpAvailability.innerHTML = '';
      }
      //END - change pickup locations
      console.log("end of product changed");
      shopified.init();
    },
    //returns the active variant in the form
    getActiveVariant: function($form){
      //decode the json passed into the form via liquid url_param
      //$form refers to the add-to-cart class
      let variants = JSON.parse(decodeURIComponent($form.getAttribute('data-variants')));
      let formData = serialize($form),//serialize function
        //set option values to null until matched
        formOptions = {
          option1: null,
          option2: null,
          option3: null
        },
        selectedVariant = null;
        console.log(formData, "formData");

        //Evalute the type of a variable at runtime
        if(typeof variants !== 'undefined'){
          //decodeURIComponent is used to decode a part of the URI
          variants = JSON.parse(decodeURIComponent($form.getAttribute('data-variants')));
        }
        //for each item in the formData - retreive the options
        formData.forEach(function(item, index){
          if(item.name){
            //if the position of the first occurrence of the item name option
            //is not equal to the last item element
            if(item.name.indexOf("option") !== -1){
              console.log(item.name, item.value);
              formOptions[item.name] = item.value; //match the name and value of the option
            }
          }
        });
        //loop over each variant and compare each one to our forms options object to get the correct variant
        if(variants != null){
          variants.forEach(function(variant, index){
            if(variant.option1 === formOptions.option1 && variant.option2 === formOptions.option2 && variant.option3 === formOptions.option3){
              selectedVariant = variant;//overide selectedVariant of null with the current variant object
              return false;//loop break
            }
          });
        }
        console.log(variants);
        console.log(formData);
        console.log(formOptions);
        return selectedVariant;//return the result/value of selectedVariant
    },
    showShare: function(){
      var shareBtn = document.querySelector('.share-btn');
      var shareModal = document.querySelector('.share-alert');
      if(shareBtn != null) {
        //show/hide product URL
        var showModal = false;
          shareBtn.onclick = function(){
           if(!showModal){
            //show
            showModal = true;
            shareModal.classList.remove("d-none");
            shareModal.classList.add("d-block");
           }
           else {
            //hide
            showModal = false;
            shareModal.classList.remove("d-block");
            shareModal.classList.add("d-none");
            document.querySelector('.share-copy-link').innerHTML = `
            <label for="copy-link">${window.theme.copy}</label>
            `
          }
        };
      }
    },
    validate: function(self, selectedVariant){
      let
        $form = self,//refers to addToCartFormSelector
        hasVariant = selectedVariant !== null,//do we have a variant?
        $id = $form.querySelector('.js-variant-id'),
        $planId = $form.querySelector('.js-selling-plan-id'),
        $addToCartButton = $form.querySelector('.add-to-cart-button'),
        $qtyPicker = document.querySelector('.js-quantity-field-pdp'),
        quantityValue = parseInt($qtyPicker.value),
        $qtyPickerPlus = $form.querySelector('.js-plus'),
        $qtyPickerMinus = $form.querySelector('.js-minus'),
        $price = $form.querySelector('.js-price'),
        $unitPrice = $form.querySelector('.js-unit-price'),
        $unitMeasure = $form.querySelector('.js-unit-measure'),
        $btn = $form.querySelectorAll('.js-btn-cta'),
        $comparePrice = $form.querySelector('.js-price-compare'),
        formattedVariantPrice = '',
        formattedVariantComparePrice = '',
        priceHtml = '',
        btnHtml = '',
        unitPriceHtml = '',
        unitMeasureHtml = '',
        comparePriceHtml = '';

      var btnDataTxt = document.querySelector('.js-cart-link');
      var btnDataPrice = document.querySelector('.js-price');
      var btnInnerTxt = btnDataTxt.dataset.add;
      var btnInnerTxtSoldout = btnDataTxt.dataset.soldout;
      var variantTitle = document.querySelector('.pickup-availability-variant');

      //change prices on select change
      const changeProductPrices = function(){
        if($form.closest('.product-item')){
          $form.closest('.product-item').querySelector('.js-price').innerHTML = '<span class="money">' + defaultPrice + '</span>';
          if($form.closest('.product-item').querySelector('.js-price-compare')){
            $form.closest('.product-item').querySelector('.js-price-compare').innerHTML = '<span class="compare money">' + comparePrice + '</span>';
          }
          if($form.closest('.product-item').querySelector('.js-unit-price')){
            $form.closest('.product-item').querySelector('.js-unit-price').innerHTML = '<span class="money">' + unitPrice + '</span>';
            $form.closest('.product-item').querySelector('.js-unit-price').classList.add("added-currency");
          }
        }
        else {
          if($price != null){
            $price.innerHTML = '<span class="money">' + defaultPrice + '</span>';
          }
          //Undefined is displayed when a “Compare at price” is not listed
          if($comparePrice != null || $comparePrice != undefined){
            $comparePrice.innerHTML = '<span class="compare money">' + comparePrice + '</span>';
          }
          if(($comparePrice == null || $comparePrice == undefined) && $comparePrice){
            $comparePrice.innerHTML = '';
          }
          if($unitPrice != null){
            $unitPrice.innerHTML = '<span class="money">' + unitPrice + '</span>';
            document.querySelector('.js-unit-price').classList.add("added-currency");
          }
        }
        document.querySelector('.js-price').classList.add("added-currency");
      }
      if(hasVariant){
        //Show stock counter with icon
        if(document.querySelector(".product-block--stock-point")){
          document.querySelector(".product-block--stock-point").classList.remove('hidden');
        }
        //Show sticky form
        if(document.querySelector("#sticky-form-wrapper")){
          document.querySelector("#sticky-form-wrapper").classList.remove('hidden');
        }
        //change default price
        var defaultPrice = Shopify.formatMoney(selectedVariant.price, window.theme.moneyFormat);
        var unitPrice = Shopify.formatMoney(selectedVariant.unit_price, window.theme.moneyFormat);

        if(variantTitle != null)
          variantTitle.innerHTML = (selectedVariant.public_title);//change pickup modal variant title to selected variant
          //only append id to URL on product page when option changes
          if(document.body.getAttribute("id") == "product"){
            window.history.replaceState(null, null, '?variant='+selectedVariant.id);//if there is a variant, append the id to the URL
          }
      } else {
        //if product does not have a variant price - change default price
        var prod = JSON.parse(self.querySelector(".selectedVariantObject").innerHTML);
        if (prod){
          var defaultPrice = Shopify.formatMoney(prod.price, window.theme.moneyFormat);
          var unitPrice = Shopify.formatMoney(prod.unit_price, window.theme.moneyFormat);
          //change prices
          changeProductPrices();
          if($price != null){
            priceHtml = $price.getAttribute('data-default-price');
          }
          if($unitPrice != null)
            unitPriceHtml = $unitPrice.getAttribute('data-unit-price');
          else
            unitPriceHtml = '';
        }
      }
      //THIS CODE IS SHOWING ERRORS AND POSSIBLE CONFLICTS
      if(hasVariant && selectedVariant.compare_at_price > selectedVariant.price){
        //change compare price
        var comparePrice = Shopify.formatMoney(selectedVariant.compare_at_price, window.theme.moneyFormat);
        //only append id to URL on product page when option changes
        if(document.body.getAttribute("id") == "product"){
          window.history.replaceState(null, null, '?variant='+selectedVariant.id);
        }
        console.log(typeof(comparePriceHtml));
        changeProductPrices();
      }

      //remove compare price when is undefined or null
      const compareEl = document.querySelector(".js-price-compare");
      if(compareEl != null) {
        if($form.closest('.product-item')) {
          var $comparePrice2 = $form.closest('.product-item').querySelector('.js-price-compare');
          if($comparePrice2 != null || $comparePrice2 != undefined) {
            $comparePrice2.style.display = 'inline-flex';
            comparePriceHtml = $comparePrice2.getAttribute('data-compare-price');
          }
          if($comparePrice2) {
            if(selectedVariant) {
              if(selectedVariant.compare_at_price == null || selectedVariant.compare_at_price == undefined ) {
                $comparePrice2.style.display = 'none';
              }
            }
          }
          else {
            var createS = document.createElement('s');
            createS.classList.add("js-price-compare");
            $form.closest('.product-item').querySelector('.js-price').after(createS);
            $form.closest('.product-item').querySelector('.js-price').after('  ');
            $comparePrice2 = $form.closest('.product-item').querySelector('.js-price-compare');
            if(selectedVariant) {
              if(selectedVariant.compare_at_price == null || selectedVariant.compare_at_price == undefined ) {
                $comparePrice2.style.display = 'none';
              }
            }
          }
        }
        else {
          if($comparePrice != null || $comparePrice != undefined) {
            compareEl.style.display = 'inline-flex';
            comparePriceHtml = $comparePrice.getAttribute('data-compare-price');
          }
          if(selectedVariant) {
            if(selectedVariant.compare_at_price == null || selectedVariant.compare_at_price == undefined ) {
              compareEl.style.display = 'none';
            }
          }
        }
      }
      //toggle button attr and change btn text based on availability
      const toggleAvailablity = () => {
        const varInv = document.querySelector('#variant-inventory');
        const pdpPrice = document.querySelector('#pdp-prices');
        const unitPdp = document.querySelector('.unit-prices');

        console.log('change btn attr and text on change');
        if(selectedVariant && selectedVariant != undefined){
          document.querySelector(".product-page-price-wrp").classList.remove('d-none');
          document.querySelector(".product-page-price-wrp").classList.add('d-block');

          //add visibility
          if(varInv != null){
            varInv.classList.add('d-block');
          }
          if(pdpPrice != null){
            pdpPrice.classList.add('d-flex');
          }
          if(unitPdp != null){
            unitPdp.classList.add('d-block');
          }
          // WITH STOCK - inventory is 1 or higher and inventory is tracked by shopify
          if(selectedVariant.inventory_quantity >= 1 && selectedVariant.available){
            $id.value = selectedVariant.id;
            $addToCartButton.disabled = false;
            $qtyPicker.disabled = false;
            if($qtyPickerPlus){
              $qtyPickerPlus.disabled = false;
            }
            if($btn != null){
              $btn.forEach(function(_btn) {
               if(document.querySelector(".spg-radio-input") != null){
                var isSubscription = document.querySelector(".spg-radio-input").checked;
                 if(isSubscription){
                    _btn.innerText = `${window.theme.addSubscription}`;
                   } else {
                    _btn.innerText = `${window.theme.addToCart}`;
                    if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').removeAttribute('disabled', 'disabled');}
                   }
                 } else {
                   _btn.innerText = `${window.theme.addToCart}`;
                   if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').removeAttribute('disabled', 'disabled');}
                 }
              });
            }
          }
          //SOLD OUT - when inventory equals 0 and inventory is tracked by shopify
          if(selectedVariant.inventory_quantity <= 0 && selectedVariant.available == false){
            $id.value = '';
            $addToCartButton.disabled = true;
            $qtyPicker.disabled = true;
            if($qtyPickerPlus){
              $qtyPickerPlus.disabled = true;
            }
            if($btn != null){
              $btn.forEach(function(_btn) {
                _btn.innerText = `${window.theme.outOfStock}`;
                if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').setAttribute('disabled', 'disabled');}
              });
              //change sticky btn text
              if(document.querySelector('.js-sticky-cta') != null){
                if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').setAttribute('disabled', 'disabled');}
              }
            }
          }
          //AVAILABLE - inventory is 0 and inventory is not tracked by shopify
          if(selectedVariant.inventory_quantity <= 0 && selectedVariant.inventory_management == null){
            $id.value = selectedVariant.id;
            $addToCartButton.disabled = false;
            $qtyPicker.disabled = false;
            if($qtyPickerPlus){
              $qtyPickerPlus.disabled = false;
            }
            if($btn != null){
              $btn.forEach(function(_btn) {
                if(document.querySelector(".spg-radio-input") != null){
                var isSubscription = document.querySelector(".spg-radio-input").checked;
                 if(isSubscription){
                   _btn.innerText = `${window.theme.addSubscription}`;
                 } else {
                   _btn.innerText = `${window.theme.addToCart}`;
                   if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').removeAttribute('disabled', 'disabled');}
                 }
               } else {
                 _btn.innerText = `${window.theme.addToCart}`;
                 if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').removeAttribute('disabled', 'disabled');}
               }
             });
            }
          }
          changeProductPrices();
          console.log($qtyPicker);
        } else if(selectedVariant == null) {
          console.log('not available...');
          document.querySelector(".product-page-price-wrp").classList.add('d-none');
          document.querySelector(".product-page-price-wrp").classList.remove('d-block'); //Hide stock counter with icon
          //Hide stock counter with icon
          if(document.querySelector(".product-block--stock-point")){
            document.querySelector(".product-block--stock-point").classList.add('hidden');
          }
          //Hide sticky form
          if(document.querySelector("#sticky-form-wrapper")){
            document.querySelector("#sticky-form-wrapper").classList.add('hidden');
          }
          if($btn != null ){
            $btn.forEach(function(_btn) {
              setTimeout(function(){
               _btn.closest('button').setAttribute("disabled", "disabled");
               if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').setAttribute('disabled', 'disabled');}
             }, 0);
              _btn.innerText = `${window.theme.unavailable}`;
            });
          }
          //remove visibility
          if(varInv != null){
            varInv.innerHTML = "<div class=\"stock-message-sold-out\"><span class=\"stock-number\">".concat(window.theme.unavailability, "</span></div>");
            document.querySelector(".product-block--stock-point").classList.remove('hidden');
            //varInv.classList.add('d-none');
          }
          if(pdpPrice != null){
            pdpPrice.classList.add('d-none');
            pdpPrice.classList.remove('d-flex');
          }
          if(unitPdp != null){
            unitPdp.classList.add('d-none');
            unitPdp.classList.remove('d-block');
          }
        }
      }
      //call the functions
      toggleAvailablity();
      state.changeCollectionPage();
    },
    init: function(selectedVariant){
      document.querySelectorAll(productOptionSelector).forEach(function(item, index){
        item.onchange = function(selectedVariant){
          var self = this;
          productForm.onProductOptionChanged(self);
          if(selectedVariant != undefined){
            if(selectedVariant.inventory_management == 'shopify' || selectedVariant.available == true) {
              state.changeMaxQuantity();
            }
          }
          state.getTheCartContent();
        }
      });
      if(document.querySelector(addToCartFormSelector) != null){
        document.querySelector(addToCartFormSelector).onchange = function(){
          console.log("form validate is called");
          var self = this;
          //productForm.validate(self, selectedVariant);
        }
      }
      // variant radio buttons
      var radioWraps = document.querySelectorAll('.styled-pills-radio');
      if(radioWraps != null){
        radioWraps.forEach(function(radioWrap,index){
          var radios = radioWrap.querySelectorAll('input[type="radio"]');
          if(radios != null){
            radios.forEach(function(radio,index){
              radio.onchange = function(){
                var selectedRadio = radio.value;
                var dropdownSelect = radio.closest('.styled-pills-radio').querySelector('select');
                 if(dropdownSelect != null){
                     dropdownSelect.value = selectedRadio;
                     dropdownSelect.onchange();
                 }
               }
            });
          }
        });
      }
      //show share link on PDP
      productForm.showShare();
      //show details info on PDP
      // productForm.showDetails();
    }
  };
  //initiate the function
  document.addEventListener("DOMContentLoaded", function(){
    productForm.init();
  });
  //END PRODUCT OPTIONS

  //START - add product to cart logic
  let miniCartContentsSelector = document.querySelector('.js-mini-cart-contents');
  let addingCartText = document.querySelector('.js-btn-cta');
  let activeBtn = undefined;

  let shopified = {
    onAddToCart: function(self, qty, selectedVariant){

      //Start upsell and what's included product
      var ids = [];
      if (document.querySelectorAll('input[name="upsellProduct[]"]').length > 0) {
        var upsells = document.querySelectorAll('input[name="upsellProduct[]"]:checked');
        if (upsells.length > 0) {
          upsells.forEach(function(item, index) {
            var value = item.value;
            ids.push(value);
          });
        }
      }
      //End upsell product
      //Start what's included product
      if (document.querySelectorAll('input[name="includedProduct[]"]').length > 0) {
        var includeds = document.querySelectorAll('input[name="includedProduct[]"]:checked');
        if (includeds.length > 0) {
          includeds.forEach(function(item, index) {
            var value = item.value;
            ids.push(value);
          });
        }
      }
      var arrIndex = 0;

      function addAdditionalProductsToCart(includedProductID) {

        if (upsells.length > 0) {
          // uncheck seleted products
          upsells.forEach(function(item, index) {
            var value = item.value;
            if(value == includedProductID){
              item.checked = false;
            }
          });
        }

        var includedProductUpdates = {
          "id": includedProductID,
          "quantity": 1
        };
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(includedProductUpdates) //convert value to a JSON string
        }).then(function(response) {
          if (response.status !== 200) {
            return response.json();
          }
          if (arrIndex < ids.length) {
            arrIndex++;
            addAdditionalProductsToCart(ids[arrIndex]);
          }
          console.log('included product added', response);
          shopified.onCartUpdated();
        }).then(function(json) {
          //shopified.onCartUpdated();
        }).catch((err) => {
          if (arrIndex < ids.length) {
            arrIndex++;
            addAdditionalProductsToCart(ids[arrIndex]);
          }
          console.log('Rejected', err);
        });
      }
      //End what's included and upsell product

      //gift recipient line item properties
      var properties = null;
      if(self.querySelector('input[name="properties[Recipient email]"]') != null && self.querySelector('input[name="properties[Recipient name]"]') != null && self.querySelector('textarea[name="properties[Message]"]') != null && self.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]') != null) {
        var gift_email = self.querySelector('input[name="properties[Recipient email]"]').value,
            gift_name = self.querySelector('input[name="properties[Recipient name]"]').value,
            gift_message = self.querySelector('textarea[name="properties[Message]"]').value,
            gift_sendon = self.querySelector('input[name="properties[Send on]"]').value,
            checkboxGift = document.querySelector(".RecipientCheckbox");

        if (checkboxGift != null && checkboxGift.checked) {
          var shopifyGiftKey = '__';
          shopifyGiftKey += '';
          shopifyGiftKey += 'shopify_send_gift_card_to_recipient';

          var gift_control_status = self.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]').value;
          console.log(shopifyGiftKey);
        } else {
          var shopifyGiftKey = null;
          var gift_control_status = null;
        }

      properties = {
          [shopifyGiftKey]: gift_control_status,
          'Recipient email': gift_email,
          'Recipient name': gift_name,
          'Message': gift_message,
          'Send on': gift_sendon
        };
      }

      let quantity = self.querySelector("input[name=quantity]").value,//qty
          id = self.querySelector("#js-product-id").value,//id
          //data for fetch api
          addData = {
            'id': self.querySelector("#js-product-id").value,
            'quantity': self.querySelector("input[name=quantity]").value,
            'properties': properties
          };
      //add subscription products data
      const sellingPlanEl = self.querySelector("[name=selling_plan]");
        if(sellingPlanEl){
          if(sellingPlanEl.value != '' ){
           //data for fetch api
           addData = {
             'id': self.querySelector("#js-product-id").value,
             'quantity': self.querySelector("input[name=quantity]").value,
             'selling_plan': self.querySelector("[name=selling_plan]").value
          };
        }
      }
      //end add subscription products data
      //loading io on add to cart form
      var btnText = self.querySelector("[data-adding-cart]").innerHTML;
      if(self.querySelector("[data-adding-cart]") && self.querySelector(".ldld")){
        self.querySelector("[data-adding-cart]").innerHTML = '';
        self.querySelector(".ldld").classList.add('running');
        self.querySelector(".ldld").classList.remove('hidden');
      }
      console.log(addData, "addData");
      var status_code = undefined;
      var status_message = undefined;
      var errorMessageWrp = document.querySelector('.add-to-cart-error');
      var errorMessage = document.querySelector('.add-to-cart-error-message');

      var request = fetch("/cart/add.js", {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(addData),
      })
      .then(res => res.json())
      .then(function(res){
        console.log(res, 'res');
        if(ids.length > 0) {
          if(self.closest('#product-info') != null || self.closest('.menu-float__item') != null){
            addAdditionalProductsToCart(ids[0]);
          }
        }
        status_code = res.status;
        status_message = res.description;
        var id = document.querySelector('#js-product-id').value;
        var quantity = document.querySelector('.js-quantity-field-pdp').value;
        state.changeAddedQuantity(res.id, res.quantity);
        state.changeMaxQuantity();
        state.getTheCartContent();
      })
      .then(function(res) {
        // addGift.onAddToCartGift();
      })
      .then(function(res) {
        //loading io change
        if(self.querySelector("[data-adding-cart]") && self.querySelector(".ldld")){
          self.querySelector("[data-adding-cart]").innerHTML = btnText;
          self.querySelector(".ldld").classList.remove('running');
          self.querySelector(".ldld").classList.add('hidden');
        }
        if(status_code == 422){
          if(errorMessageWrp != null) {
            errorMessageWrp.classList.remove('hidden');
            errorMessage.innerHTML = status_message;
          }
        } else {
         if(errorMessageWrp != null) {
            errorMessageWrp.classList.add('hidden');
            errorMessage.innerHTML = '';
          }
         shopified.cartSuccess();
        }
      })
      .then(function(res) {
        // shopified.openCart();
      })
      .then(function(res){
        //reset qty picker value on submit
        document.querySelector('.js-quantity-field-pdp').value = 1;
      })
      .then(() => {
        console.log('changes to shipping value');
      })
      .catch((err) => {
        console.log('Rejected', err);
      });
    },
    cartSuccess: function(){
      shopified.onCartUpdated();
        new Noty({
          theme: 'nest',
          type: 'success',
          timeout: 1000,
          layout: 'topRight',
          text: `${window.theme.addedToCart}`,
      }).show();
      console.log('Noty alert executed')
    },
    updateCartTotals: function() {
      var bar = document.querySelector('.announcement-bar');
      if(bar != null){
        var promote_txt = bar.dataset.promote;
        var unlocked_txt = bar.dataset.unlocked;
        var threshold = 0;
        threshold = Math.round(bar.dataset.threshold);
      }
      //This function returns a promise
       const update = async () => {
         const res = await fetch('/cart.js', { method: "GET" });
         const cart = await res.json();
         return cart;
       }
       //here is the data from the response
       update()
       .then((cart) => {
         var rate = Shopify.currency.rate;
         threshold = threshold * rate;
         var current_currency_valof1 = 1/(rate);
         var cart_count = Number(cart.item_count);
         var cart_total = Math.round(cart.total_price);
         // var cart_total = Math.round((cart.total_price)*(current_currency_valof1));
         var cartFloat = document.querySelector('.js-menu-toggle');
         var jsCartTotal = document.querySelector('.total-price-js');
         // console.log('cart_total', cart_total, threshold, cart_count);

         //change total price/count in cart
         var $cartTotal = document.querySelectorAll('.js-cart-item-total');
         var $cartCount = document.querySelectorAll('.js-cart-item-count');

         $cartTotal.forEach(function(item) {
           if(item != null) {
             item.innerHTML = Shopify.formatMoney(cart_total, window.theme.moneyFormat);
           }
         });

         //change cart count in cart
         var $cartCount = document.querySelectorAll('.js-cart-item-count');
         $cartCount.forEach(function(item) {
           item.innerHTML = (cart_count);
         });

         productForm.init();
         shopified.init();
         // console.log('init product form on cart change');

         //change cart total in cart for free shipping
         if(bar != null){
           // threshold = threshold * (rate || 1);
           var barText = unlocked_txt;
           if(threshold > cart_total){
             var value_left =  Math.round((threshold - cart_total));
             // var value_left_in_currency = Math.round(value_left/current_currency_valof1);
             var value_left_in_currency = Math.round(value_left);
             var remaining_amount = Shopify.formatMoney(value_left_in_currency, window.theme.moneyFormat);
             barText = promote_txt.replace('[value]', remaining_amount);
           } else {
             barText = unlocked_txt;
           }
           var barAll = document.querySelectorAll('.js-announcement-bar-cart');
           barAll.forEach(function(bar,index){
            bar.querySelector('p').innerHTML = barText;
           });
         }
       })
       .catch((error) => {
         console.log(error);
      });
    },
    onCartUpdated: function(isInMiniCart = false, self = null) {
      var currentLanguage = JSON.stringify(`${window.theme.language}`);//Jsonresult from script-tags.liquid
      var selectedLanguage = new String();//create new string

      selectedLanguage = currentLanguage.toString().replace(/"/g, "");//remove quotes
      console.log('The site language is', selectedLanguage);
      selectedLanguage = (selectedLanguage && selectedLanguage == 'en') ? '' : '/'+selectedLanguage;

      //varinat ID an qty's
      let vid = '',
          vquantity = '';

      console.log(isInMiniCart, "isInMiniCart");
      //if in minicart use the qty and ids of products to update
      if(isInMiniCart){
        vid = self.getAttribute("id");
        vquantity = self.value;
      }
      //otherwise use the select variant id from the form and qty picker value
      else {
        let isQuantity = document.querySelector(".quantity input[name=quantity]");
        let vid = document.querySelector(".js-variant-id");
        if(vid != null){
          vid.value;
        }
        if(isQuantity){
          vquantity = isQuantity.value
        }
      }
      let addData = {
        'id': vid,//variant id
        'quantity': vquantity //variant qty
      };
      //start of fetch
      var request = fetch("/cart", {
        method: "GET",
        context: document.body
      })
      .then(res => res.text())
      .then((context) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(context, 'text/html');
        //for cart page
        if(document.body.getAttribute("id") == "cart"){
          //reassign the ref to the cart page from mini-cart
          miniCartContentsSelector = document.querySelector('.js-cart-page-contents');
        }
        var $minicart = doc.querySelector("#mini-cart");
        let $dataCartContents = doc.querySelector('.js-cart-page-contents'),
            $dataCartContentsPrice = doc.querySelector('.js-total'),
            dataCartHtml = $dataCartContents.innerHTML,
            dataCartItemCount = $dataCartContents.getAttribute('data-cart-item-count'),
            dataCartItemTotal = $dataCartContentsPrice.getAttribute('data-cart-item-total'),
            $cartItemCount = document.querySelectorAll('.js-cart-item-count'),
            $closeIcon = document.querySelector('.js-close-cart'),
            $cartItemTotal = doc.querySelector('.js-cart-item-total');

        if($cartItemCount !== null){
          $cartItemCount.forEach(function(item) {
            item.innerText = dataCartItemCount;
          });
        }

        console.log(dataCartHtml, 'dataCartHtml');
        console.log(dataCartItemCount, 'dataCartItemCount');
        console.log(dataCartItemTotal, 'dataCartItemTotal');
        console.log($dataCartContentsPrice, '$dataCartContentsPrice');

        if($cartItemTotal !== null) {
          $cartItemTotal.innerHTML = ('<span class="money">' + dataCartItemTotal + '</span>');
        }
        if(miniCartContentsSelector !== null) {
          miniCartContentsSelector.innerHTML = dataCartHtml;
        }
        if(parseInt(dataCartItemCount) !== 0){
          runScripts(miniCartContentsSelector);
        }
        if(parseInt(dataCartItemCount) > 0){
          //dont show cart on mobile
          if (window.innerWidth < 960) {
            shopified.closeCart();
            lineItem.init();
            quantityPicker.init();
          }
          //otherwise open cart on desktop
          else {
            shopified.openCart();
          }
          if(isInMiniCart){
          	var minus = document.querySelector('.js-minus');
            if(minus)
              minus.disabled = true;
          }
        }
        else {
          shopified.closeCart();
        }
        //close the cart drawer when clicking on x in cart header
        function closeClick(event){
          document.body.classList.remove('show-sidebar');
          console.log('close icon btn clicked');
        }
        //call the closeClick function
        var closeCart = document.querySelector('.js-close-cart');
        if(closeCart !== null){
          closeCart.addEventListener('click', closeClick);
        }
        //end call the closeClick function
      })
      .then(() => {
        //disable collection page button
        state.changeCollectionPage();
        state.getTheCartContent();
        shopified.slimSelect();
      })
      .catch((err) => {
        console.log('Rejected', err);
      });
      //end of fetch

      //reset pdp qty value to 1 once add to cart has been clicked
      if(isInMiniCart){
        if(qtyBtnPdp)
      	var qtyBtnPdp = document.querySelector(".js-quantity-field-pdp").value = '1';
      }
    },
    onError: function(XMLHttpRequest, textStatus){
      let data = XMLHttpRequest.responseJSON;
      alert(data.status + ' - ' + data.message + ': ' + data.description);
    },
    openCart: function(){
      console.log("The cart drawer should be open");
      let isInCartPage = window.location.href.indexOf('/cart') === -1;
      if(isInCartPage) {
        document.body.classList.add('show-sidebar');
      }
      if(document.querySelector(".js-close-cart") !== null){
        document.querySelector(".js-close-cart").onclick = function() {
          document.body.classList.remove('show-sidebar');
        }
      }
      //to attach the click functions on the dynamically loaded content of the cart drawer
      lineItem.init();
      quantityPicker.init();
      shopified.updateCartTotals();
    },
    closeCart: function(){
      console.log("close cart");
      if(document.querySelector('show-sidebar') !== null){
        document.body.classList.remove('show-sidebar');
      }
    },
    onCartButtonClick: function(){
      console.log("onCartButtonClick");
      let isCartOpen = document.body.classList.contains('show-sidebar');
      console.log(isCartOpen, "isCartOpen");
      if(isCartOpen == false){
        window.location.href = '/cart';
      }
      let isInCart = window.location.href.indexOf('/cart') === -1;
      console.log(isInCart, "isInCart");
      if(!isInCart) {
        if(!isCartOpen) {
          shopified.openCart();
        }
      }
    },
    slimSelect: function() {
      var imgVarSelect = document.querySelectorAll('.swatches-with-variant-image.select2 option');
      var data = [];
      if (imgVarSelect != null) {
        imgVarSelect.forEach(function(option, index) {
          console.log('option111',option);
          var variantimage = option.dataset.variantimage;
          var title = option.dataset.value;
          if (variantimage != undefined && title != undefined) {
            var image = '<span class="variant-title-image"><span class="variant-title">' + title + '</span><img src="' + variantimage + '"></span>';
            data.push({
              html: image,
              text: image,
              value: title
            });
          }
        });
      }
      const selects = document.querySelectorAll(`select.select2:not([data-ssid])`);
      if (selects != null) {
        selects.forEach((selectElement) => {
          console.log('Slim select dropdowns loaded');
          let specialSelect = selectElement;
          var selectClass = specialSelect.className;
          var additionalData = null;
          if (selectClass.includes('swatches-with-variant-image')) {
            additionalData = data;
          }
          new SlimSelect({
            select: specialSelect,
            closeOnSelect: true,
            showContent: 'up',
            hideSelectedOption: false,
            showOptionTooltips: false,
            showSearch: false,
            data: additionalData,
            onChange: (info) => {
              if (selectClass.includes('color-option-swatch')) {
                var colorClass = info.class;
                if (colorClass.includes('color')) {
                  var colorSwatches = specialSelect.closest('.product-option-row').querySelector('.ss-main.color-option-swatch');
                  var colorSelected = colorSwatches.querySelector('.placeholder');
                  colorSelected.className = '';
                  colorSelected.classList.add(colorClass);
                  colorSelected.classList.add('placeholder');
                }
              }
            },
            afterOpen: function() {
              var selectClass = specialSelect.className;
              if (selectClass.includes('color-option-swatch')) {
                var productUrl = specialSelect.getAttribute('data-product-url');
                var moreColors = specialSelect.closest('.product-option-row').querySelector('.ss-option.swatch-view-more');
                if (productUrl != '' && moreColors != null) {
                  moreColors.setAttribute('title', 'View More');
                  moreColors.onclick = function(e) {
                    e.preventDefault();
                    window.location.href = productUrl;
                  }
                };
              }
            },
          });
        });
      }
    },
    init: function(){
      // bundle product add to cart
      document.addEventListener('shopify-bundle-products:init-product-bundle', function (event) {
        var variant_ids = event.detail.variant_ids;
        var bundleBtn = event.detail.bundleBtn;
        if(variant_ids.length > 0){
          var loader = bundleBtn.querySelector('.ldld');
          var addItemsSpan = bundleBtn.querySelector('.add-bundle-items-to-cart');
          if(addItemsSpan != null && loader != null){
            addItemsSpan.classList.add('hidden');
            loader.classList.remove('hidden');
            loader.classList.add('running');
          }
          var i = 0
          variant_ids.forEach(function(variant,index){
            var id = variant.var_id;
            var selling_plan = variant.selling_plan;
            setTimeout(function(){
            let addData = {
              'id': id,
              'quantity': 1,
              'selling_plan': selling_plan
            };
            var request = fetch("/cart/add.js", {
              method: "POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(addData),
            }).then(res => res.json())
            .then(function(res){
              console.log('res',res)
              if(variant_ids.length == index + 1){
                shopified.cartSuccess();
                if(addItemsSpan != null && loader != null){
                  bundleBtn.setAttribute('disabled',true);
                  addItemsSpan.classList.remove('hidden');
                  loader.classList.add('hidden');
                  loader.classList.remove('running');
                }
              }
            })
            },i);
            i = i + 1000;
          });
        }
      });
      // console.log(addToCartFormSelector, 'addToCartFormSelector');
      if(document.querySelector(addToCartFormSelector)){
        // console.log(addToCartFormSelector);
        document.querySelectorAll(addToCartFormSelector).forEach(function(item, index){
          item.onsubmit = function(e){
            e.preventDefault();
            console.log("addtocart form submitted");
            var qty = null, temp_total = null, final_qty = null;
            console.log("addtocart form submitted");

            //check if max quanity is already in cart and get cart object
            //find the item quantity and get available quantity and compare
            var request = fetch("/cart.js", {
              method: "GET",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            })
            .then(res => res.json())
            .then(function(res){
              let available = false;
              console.log("quantity field", item.querySelector(".stock-number"));
              if(item.querySelector(".stock-number")){
                var ava_qty = Number(item.querySelector(".stock-number").innerHTML);
              }
              if(res.items.length > 0) {
                console.log(item.querySelector("#js-product-id").value, "product id");
                res.items.forEach(function(_item, index){
                  console.log(_item.id , "cart item id");
                  if(_item.id == item.querySelector("#js-product-id").value){
                    console.log(_item.quantity, "_item.quantity");
                    console.log('item quantity will be visible here',ava_qty,  _item.quantity)
                    if(_item.quantity >= ava_qty){
                      available = true;
                      item.querySelector("button[name=add]").style.cursor = "auto";
                      new Noty({
                        theme: 'nest',
                        type: 'alert',
                        timeout: 1000,
                        layout: 'topRight',
                        text: `${window.theme.inventoryMax}`,
                      }).show();
                      return false;
                    } else {
                      if(_item.quantity < ava_qty){
                        qty = item.querySelector("input[name=quantity]").value;
                        temp_total = Number(qty) + Number(_item.quantity);
                        if(temp_total > ava_qty){
                          final_qty = ava_qty - _item.quantity;
                        } else {
                          final_qty = qty;
                        }
                        item.querySelector("input[name=quantity]").value = final_qty;
                      }
                    }
                  }
                });
              } else available = false;
              console.log(available);
              if(!available){
                console.log("shopified.onaddtocart is called", qty);
                var checkboxGift = document.querySelector(".RecipientCheckbox");
                var errorMessageElement = document.querySelector('.invalid-feedback');
                var emailMessage = `${window.theme.giftcardLabel}`;
                var errorMessage = `${window.theme.giftcardError}`

                if (checkboxGift != null && checkboxGift.checked) {
                  if(item.querySelector('input[name="properties[Recipient email]"]') != null && item.querySelector('input[name="properties[Recipient name]"]') != null && item.querySelector('textarea[name="properties[Message]"]') != null) {
                    var gift_email = item.querySelector('input[name="properties[Recipient email]"]').value,
                        gift_name = item.querySelector('input[name="properties[Recipient name]"]').value,
                        gift_message = item.querySelector('textarea[name="properties[Message]"]').value;

                    if(gift_email == ''){
                       errorMessageElement.innerText = errorMessage;
                       errorMessageElement.style.color = '#dc3545';
                       return true;
                    } else {
                      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                      if(gift_email.match(mailformat)){
                        errorMessageElement.innerText = '';
                      } else {
                        errorMessageElement.innerText = emailMessage;
                        errorMessageElement.style.color = '#dc3545';
                        return true;
                      }
                    }
                  }
                }
                shopified.onAddToCart(item, qty, selectedVariantData);//item refers to self passed into the onAddToCart function/method
                if(document.querySelector('.js-minus') != null){
                  document.querySelector('.js-minus').disabled = true;
                }
              }
            })
            .catch((err) => {
              console.log('Rejected', err);
            });
          }
        });
      };
      if(document.querySelector(".js-menu-toggle")){
        var sidebar = document.querySelectorAll(".js-menu-toggle");
        if (sidebar.length > 0) {
          sidebar.forEach(function (item, index) {
            item.addEventListener("click", function (e) {
              e.preventDefault();
              shopified.openCart();
              shopified.onCartButtonClick();
            });
          });
        }
      }
      if(document.querySelector('body #mini-cart .js-keep-shopping')){
          document.querySelector('body #mini-cart .js-keep-shopping').onclick = function(e){
          e.preventDefault();
          shopified.onCartButtonClick();
        }
      }
      //call slim select globally
      shopified.slimSelect();
      //color swatch matching
        if(document.querySelectorAll('select.color-option-swatch')){
        var colorOptionsAll = document.querySelectorAll('select.color-option-swatch');
        colorOptionsAll.forEach(function(item,index){
        var colorDefaultClass = item.querySelector('option:checked');
        if(colorDefaultClass != null){
          var colorClass = colorDefaultClass.className;
            if(colorClass.includes('color')){
              var colorSwatches = item.closest('.product-option-row').querySelector('.ss-main.color-option-swatch');
              if(colorSwatches != null) {
                var colorSelected = colorSwatches.querySelector('.placeholder');
                colorSelected.className = '';
                colorSelected.classList.add(colorClass);
                colorSelected.classList.add('placeholder');
              }
            }
          }
        });
      }
    }
  };
  //initiate the function
  document.addEventListener("DOMContentLoaded", function() {
    shopified.init();
  });
  //initiate select library SLIM SELECT when shopidy section changes
  document.addEventListener("shopify:section:load", function() {
    shopified.slimSelect();
  });
  //END - add product to cart logic

  //initiate for the dynamic recommendations
  document.addEventListener('shopify-recommendation:init-product-grid', (event) => {
    productForm.init();
    shopified.init();
    //state.init();
  });

  //initiate for the loadmore
  document.addEventListener('shopify-collection-loader:init-product-grid', (event) => {
    productForm.init();
    shopified.init();
  });

  //START - quantity picker in the cart
  let quantityFieldSelector = '#mini-cart .js-quantity-field',
      quantityButtonSelector = '#mini-cart .js-quantity-button',
      quantityPickerSelector = '#mini-cart .js-quantity-picker',

      quantityPicker = {
        disablePlus: function(_picker, _quantity, _quantityValue){
          if(_picker.querySelector('.update_span').classList.contains('selling_plan')){
            _quantity.value = 1;
          } else {
            _quantity.value = (_quantityValue + 1);
          }
          console.log('selling plan actions ', _picker, _quantity, _quantityValue);
        },
        removeDuplicates: function(self){
          console.log(self);
          var divsToRemove = document.querySelectorAll(".search-results");
          for (var i = 0; i < 2; i++) {
            if(divsToRemove[i] != null){
              divsToRemove[i].remove();
            }
          }
        },
        onButtonClick: function(self, selectedVariant){
          let $button = self,
              $picker = $button.parentElement.parentElement,
              $quantity = $picker.querySelector('.js-quantity-field'),
              quantityValue = parseInt($quantity.value),
              max = $quantity.getAttribute('max') ? parseInt($quantity.getAttribute('max')) : null;

          if($button.classList.contains('plus') && (max === 0 || quantityValue+1 <= max)) {
            quantityPicker.disablePlus($picker, $quantity, quantityValue);
            quantityPicker.onChange($quantity);
            lineItem.onLineQuantityChange($quantity);
            state.changeAddedQuantity($picker.querySelector('.update_span').getAttribute('data-id'), $quantity.value)
            state.changeMaxQuantity();
            state.changeCollectionPage();
            state.getTheCartContent();
          }
          else if($button.classList.contains('minus')) {
            //decrease the value
            $quantity.value = (quantityValue - 1);
            quantityPicker.onChange($quantity);
            lineItem.onLineQuantityChange($quantity);
            state.changeAddedQuantity($picker.querySelector('.update_span').getAttribute('data-id'), $quantity.value)
            state.changeMaxQuantity();
            state.changeCollectionPage();
            state.getTheCartContent();
          }
        },
        onChange: function(self){
          //The parentElement property returns the parent element of the specified element.
          let $field = self,
              $picker = $field.parentElement.parentElement,
              $quantityText = $picker.querySelector('.js-quantity-text'),
              $quantitySelling = $picker.querySelector('.js-quantity-text'),
              shouldDisableMinus = parseInt(this.value) === parseInt($field.getAttribute('min')),
              shouldDisablePlus = parseInt(this.value) === parseInt($field.getAttribute('max')),
              $minusButton = $picker.querySelector('.js-quantity-button.minus'),
              $plusButton = $picker.querySelector('.js-quantity-button.plus');

          if($picker.querySelector('.update_span').classList.contains('selling_plan')){
            $picker.querySelector('.js-quantity-button.plus').disabled = true;
          }

          $quantityText.innerText = (this.value);

          if(shouldDisableMinus) {
            $minusButton.disabled = true;
            new Noty({
              theme: 'nest',
              type: 'success',
              timeout: 1000,
              layout: 'topRight',
              text: `${window.theme.itemRemoved}`,
            }).show();
          }
          else if($minusButton.disabled === true) {
            $minusButton.disabled = false;
          }
          if(shouldDisablePlus) {
            $plusButton.disabled = true;
          }
          else if($plusButton.disabled === true) {
            $plusButton.disabled = false;
          }
        },
        init: function(){
          document.querySelectorAll(quantityButtonSelector).forEach(function(item, index){
            item.onclick = function(e){
              e.preventDefault();
              quantityPicker.onButtonClick(this);
              shopified.openCart();
              quantityPicker.removeDuplicates(this);
            }
          });
          document.querySelectorAll(quantityFieldSelector).forEach(function(item, index){
            item.onchange = function(e){
              e.preventDefault();
              quantityPicker.onChange(this);
              shopified.openCart();
              quantityPicker.removeDuplicates(this);
            }
          });
        }
      };
      quantityPicker.init();
      //END - quantity picker in the cart

      //START - quantity picker on the product page
      let quantityFieldSelectorPdp = '.js-quantity-field-pdp',
          quantityButtonSelectorPdp = '.js-quantity-button-pdp',
          quantityPickerSelectorPdp = '.js-quantity-picker-pdp';

      const $selectedVariant = document.querySelector(".selectedVariantObject")
      let selectedVariantData;
      if($selectedVariant){
        selectedVariantData = JSON.parse($selectedVariant.innerHTML);//get data of selected product
      }

      let quantityPickerPdp = {
        onButtonClickPdp: function(self){
          let onButtonClickPdpLimit = '1';
          onButtonClickPdpLimit = parseInt(onButtonClickPdpLimit);
          console.log(onButtonClickPdpLimit)

          let
            $button = self,
            $form = self.closest(addToCartFormSelector),
            $picker = $button.closest(quantityPickerSelectorPdp),
            shouldDisableMinus = parseInt(self.value) === parseInt($button.getAttribute('min')),
            shouldDisablePlus = parseInt(self.value) === parseInt($button.getAttribute('max')) + onButtonClickPdpLimit,
            $inputField = $picker.querySelector('.js-minus'),
            $quantity = $picker.querySelector('.js-quantity-field-pdp'),
            $minusButton = $picker.querySelector('.js-minus'),
            $plusButton = $picker.querySelector('.js-plus'),
            quantityValue = parseInt($quantity.value),
            $minValue = document.querySelector('.js-quantity-field-pdp').getAttribute('min'),
            max = $quantity.getAttribute('max') ? parseInt($quantity.getAttribute('max')) + onButtonClickPdpLimit : null,
            min = $quantity.getAttribute('min') ? parseInt($quantity.getAttribute('min')) : null;
            console.log(max);

            if($button.classList.contains('plus') && (max === null || quantityValue +1 <= max)){
              //increase the value
              $quantity.value = (quantityValue + 1);
              //show notice and disabled inputs when max inventory is reached
              if(shouldDisablePlus){
                console.log('no more stock');
                $plusButton.disabled = true;
                $quantity.disabled = true;
                document.querySelector('.add-to-cart-button').disabled = true;
              }
            }
            else if($button.classList.contains('minus')){
              //decrease the value
              $quantity.value = (quantityValue - 1);
              //show notice and disabled minus when min is 1
                if(shouldDisableMinus) {
                $minusButton.disabled = true;
              }
            }
            quantityPickerPdp.onChangePdp($quantity);
          },
          onChangePdp: function(self) {
            console.log('qty picker on pdp', self);
            let onChangePdpLimit = '1'
            onChangePdpLimit = parseInt(onChangePdpLimit);
            console.log(onChangePdpLimit)

            let
              $field = self,
              $picker = $field.closest(quantityPickerSelectorPdp),
              shouldDisableMinus = parseInt(self.value) === parseInt($field.getAttribute('min')),//qty field == min attr
              shouldDisablePlus = parseInt(self.value) === parseInt($field.getAttribute('max')) + onChangePdpLimit,//qty field == max attr
              $minusButton = $picker.querySelector('.js-minus'),
              $inputField = $picker.querySelector('.js-quantity-field-pdp'),
              $plusButton = $picker.querySelector('.js-plus'),
              $addToCartBtns = document.querySelectorAll('.add-to-cart-button');

            //minus button
            if(shouldDisableMinus) {
              console.log($minusButton, "$minusButton");
              $minusButton.disabled = true;
            }
            else if($minusButton.disabled === true) {
              console.log($minusButton, "$minusButton");
              $minusButton.disabled = false;
            }

            //plus button
            if(shouldDisablePlus){
              $plusButton.disabled = true;
              $inputField.disabled = true;
              $addToCartBtns.forEach(function(item) {
                item.disabled = true;
              });
              new Noty({
                theme: 'nest',
                type: 'alert',
                timeout: 1000,
                layout: 'topRight',
                text: `${window.theme.inventoryLimit}`,
              }).show();
            }
            else if($plusButton.disabled) {
              $plusButton.disabled = false;
              $inputField.disabled = false;
              $addToCartBtns.forEach(function(item) {
                item.disabled = false;
              });
            }
          },
          init: function() {
            console.log("quantity picker for product loaded");
            document.querySelectorAll(quantityButtonSelectorPdp).forEach(function(item, index){
              item.onclick = function(e){
                console.log("quantityButtonSelectorPdp clicked", quantityButtonSelectorPdp);
                e.preventDefault();
                quantityPickerPdp.onButtonClickPdp(this);
              }
            });
            document.querySelectorAll(quantityFieldSelectorPdp).forEach(function(item, index){
              item.onchange = function(e){
                console.log(this);
                e.preventDefault();
                quantityPickerPdp.onChangePdp(this);//function invoked as a method
              }
            });
          }
        };
        //initiate the function
        document.addEventListener("DOMContentLoaded", function() {
          quantityPickerPdp.init();
          shopified.updateCartTotals();
        });
        //END - quantity picker on the product page

        //START - update items in the cart
        let removeLineSelector = '.js-remove-line',
            lineQuantitySelector = '.js-line-quantity';

        let lineItem = {
          isInMiniCart: function(element){
            console.log(element, "element in isminicart refers to self. Should be input value");
            let $element = element,
                $miniCart = element.closest('.js-mini-cart-contents');

            if($miniCart){
              let isInMiniCart = $miniCart.length !== 0;
              return isInMiniCart;//break
            }
          },
          onLineQuantityChange: function(self){
            console.log("onLineQuantityChange", self);
            let
              quantity = self.value,
              id = self.getAttribute('data-id'),
              line = self.getAttribute('data-line-number'),
              changes = {
                quantity: quantity,
                line: line
              },
              isInMiniCart = lineItem.isInMiniCart(self);
            console.log('JSON', JSON.stringify(changes));
            if(true){
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(changes)
              })
              .then(res => res.json())
              .then((response) => {
                //if on the same product page
                if(document.body.getAttribute("id") == "product"){
                  console.log("body id ==== product -------");
                  var form = document.body.querySelector("form[class=add-to-cart-form]");
                  if(form != null){
                    //if same variant is selected
                    if(form.querySelector("#js-product-id").value == id){
                      if(form.querySelector(".stock-number")){
                        var ava_qty = Number(form.querySelector(".stock-number").innerHTML)//stock value as a number
                      }
                      console.log("form is not null qty", quantity + "  " + ava_qty);
                      //if updated quantity is lesser than the available then enable the button
                      var btn = document.querySelector(".add-to-cart-button");
                      console.log(isNaN(Number(ava_qty)))
                      if(!isNaN(Number(ava_qty))){
                        if(Number(quantity) < ava_qty){
                          return false;
                        } else {
                            new Noty({
                              theme: 'nest',
                              type: 'alert',
                              timeout: 1000,
                              layout: 'topRight',
                              text: `${window.theme.inventoryMax}`,
                          }).show();
                          //break
                          return false;
                        }
                      }
                    }
                  }
                }
              })
              .then((response) => {
                shopified.onCartUpdated();
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            }
          },
          onLineRemoved: function(self){
            let isInMiniCart = lineItem.isInMiniCart(self);
            if(true){
              let $removeLink = self,
                  removeQuery = $removeLink.getAttribute('href').split('change?')[1];
              fetch('/cart/change.js', {
                method: 'POST',
                body: new URLSearchParams(removeQuery)
              })
              .then(cart => cart.json())
              .then((cart) => {
                console.log('testing all items removed', cart);
                if(cart.item_count < 1) {
                  const cartTotalMenu = document.querySelectorAll('.js-cart-item-total');
                  cartTotalMenu.forEach(function(item) {
                    if(item != null) {
                      item.innerHTML = Shopify.formatMoney(cart.total_price, window.theme.moneyFormat);
                      document.querySelector('.js-bubble').style.backgroundColor = "white";
                      document.querySelector('.cart-count span').style.color = "#212529";
                    }
                  });
                }
                new Noty({
                  theme: 'nest',
                  type: 'alert',
                  timeout: 1000,
                  layout: 'topRight',
                  text: `${window.theme.itemRemoved}`,
              }).show();
              })
              .then((response) => {
                shopified.onCartUpdated();
              })
            }
          },
          init: function(){
            //$miniCart is used to select the dynamically created removeLineSelector
            var $miniCart = document.querySelector("#mini-cart");//for mini cart
            if(document.body.getAttribute("id") == "cart"){
              $miniCart = document.querySelector("#page-cart");//for cart drawer
            }
            $miniCart.querySelectorAll(removeLineSelector).forEach(function(item, index){
              item.onclick = function(e){
                e.preventDefault();
                console.log("An item has been removed from the cart");
                lineItem.onLineRemoved(this);
                shopified.openCart();
                state.changeAddedQuantity(this.parentElement.querySelector('.update_span').getAttribute('data-id'), 0)
                state.changeMaxQuantity();
                state.getTheCartContent();
              }
            });
            document.querySelectorAll(lineQuantitySelector).forEach(function(item, index){
              item.onclick = function(e){
                e.preventDefault();
                console.log("lineItem.onLineQuantityChange", this);//refers to lineQuantitySelector
                lineItem.onLineQuantityChange(this);
              }
            });
          }
        }
        //initiate the function
        lineItem.init();
        //END - update items in the cart

        //START - slider on product page logic
        let sliders = '.js-slides';
        let productSlideshows = {
          sLider: {}, //to make the slider object accessible in all functions
          setup: function($element = null){
            if(document.querySelectorAll(sliders) != null){
              var allSliders = document.querySelectorAll(sliders);
              allSliders.forEach(function(productSlideshowSelector,index){
                var sectionCurrent = productSlideshowSelector.closest('section');
                var sectionID = sectionCurrent.getAttribute('id');
                var sectionMain = '#'+sectionID;
                console.log('sectionID',sectionID);
              //thumbnails
              var navContainer = false;
              let tnsthumbOptions = {
            	  loop: false,
                rewind: true,
                touch: false,
                controlsContainer: sectionMain+" #controls-thumbnails",
                container: sectionMain+' .product-thumbnails',
                items: 3,
                mode: 'carousel',
                speed: 400,
                mouseDrag: false,
                controls: true,
                nav: false,
                onInit(info) {
                  var items = document.querySelectorAll(sectionMain+' .product-thumbnails .thumb-slide');
                  items.forEach(function(item, index) {
                    item.onclick = function() {
                      var img_wrp = item.querySelector('.img-wrapper-class');
                      if (img_wrp != null) {
                        var img_id = img_wrp.dataset.imageId;
                        var medias = document.querySelectorAll('.product-media-desktop-only div#product-image .slides > div');
                        if (medias.length > 0) {
                          medias.forEach(function(media, index) {
                          var media_id = media.dataset.mediaId;
                            if (media_id != undefined) {
                              if (img_id == media_id) {
                                gsap.to(window, {
                                  duration: 0.1,
                                  scrollTo: {
                                    y: media
                                  }
                                });
                              }
                            }
                          });
                        }
                      }
                    }
                  });
                }
              };
              if(document.querySelector(sectionMain+' .thumb-slider') != null && tns !== undefined) {
                navContainer = sectionMain+' .product-thumbnails';
                let thumb_carousel = undefined,
                    thumbsOpts = {};
                let wait = null;

                function iniThumbs(){
                  if(wait !== null) clearTimeout(wait);
                  wait = setTimeout(function(){
                    if(typeof thumb_carousel === 'object') thumb_carousel.destroy();
                    if (window.matchMedia('( min-width: 768px )').matches) {
                      thumbsOpts = {axis: "vertical",items: 5};
                    }
                    else {
                      thumbsOpts = {axis: "horizontal",items: 3};
                    }
                    thumb_carousel = tns(Object.assign({},tnsthumbOptions,thumbsOpts));
                    mainMediaSlider(navContainer);
                  }, 0);
                }
                window.addEventListener('orientationchange', iniThumbs);
                window.addEventListener('resize', iniThumbs);
                iniThumbs();
              }

              //main slider
              if(document.querySelector(sectionMain+' .thumb-slider') == null) {
                navContainer = sectionMain+' .product-medaia-slider-nav';
                mainMediaSlider(navContainer);
              }

            function mainMediaSlider(navContainer) {
              // var sliderContainer = productSlideshowSelector.querySelector('.js-slides');
              var controls = productSlideshowSelector.closest('.js-product-slideshow').querySelector('.product-medaia-slider-controls');
              var previous = productSlideshowSelector.closest('.js-product-slideshow').querySelector('.previous');
              var next = productSlideshowSelector.closest('.js-product-slideshow').querySelector('.next');

              let slider = undefined,
                  mainsOpts = {};
              let main_wait = null;
              let tnsmainOptions = {
                container: productSlideshowSelector,
                items: 1,
                slideBy: 'page',
                autoplay: false,
                controls: true,
                freezable: true,
                touch: false,
                mouseDrag: false,
                controlsContainer: controls,
                navContainer: navContainer,
                navAsThumbnails: false,
                preventScrollOnTouch: 'true',
                autoplayText: ['Start', 'Stop'],
                prevButton: previous,
                nextButton: next,
                navPosition: 'bottom',
                rewind: true,
                lazyload: false,
                center: true,
                autoHeight: false,
                mode: 'carousel',
                loop: false,
                speed: 400,
                responsive: {
                  320: {
                    autoHeight: false
                  },
                  768: {
                    autoHeight: true
                  }
                },
                onInit(info) {
                	//info.container.setAttribute('tabindex', 1);
                	info.nextButton.setAttribute('tabindex', 0);
                	info.prevButton.setAttribute('tabindex', 0);
                }
                };
                 if(main_wait !== null) clearTimeout(main_wait);
                  main_wait = setTimeout(function(){
                    if(typeof slider === 'object') slider.destroy();
                    mainsOpts = {items: 1};
                    slider = tns(Object.assign({},tnsmainOptions,mainsOpts));
                    // slider.initSliderTransform();
              productSlideshows.sLider = slider;
              console.dir(productSlideshows.sLider);

              //product sticky form position adjustment
              setTimeout(function(){
                var infoWrap = document.querySelector("#product-info");
                if(infoWrap != null){
                  infoWrap.style.position = "relative";
                  infoWrap.style.removeProperty("top");
                  infoWrap.style.removeProperty("width");
                }
              }, 0);

              var customizedFunction = function customizedFunction(info, eventName) {
                // var videosWrp = document.querySelectorAll('.external-video-container,.video-container');
                var videosWrp = document.querySelectorAll(sectionMain+' .external-video-container,.video-container');
                if (videosWrp.length > 0) {
                  videosWrp.forEach(function (videoWrpCurrent) {
                    var controlsCurrent = videoWrpCurrent.querySelectorAll('.video-controls-btn .video-control');

                    if (controlsCurrent.length > 0) {
                      controlsCurrent.forEach(function (controlCurrent) {
                        if (controlCurrent.classList.contains('video-play')) {
                          controlCurrent.classList.remove('hidden');
                        } else {
                          controlCurrent.classList.add('hidden');
                        }
                      });
                    }
                    var command;
                    var iframe = videoWrpCurrent.querySelector('iframe');
                    var video = videoWrpCurrent.querySelector('video');
                    if (iframe != null) {
                      if (iframe.classList.contains('js-vimeo')) {
                        command = {
                          "method": "pause",
                          "value": "true"
                        };
                      }
                      if (iframe.classList.contains('js-youtube')) {
                        command = {
                          "event": "command",
                          "func": "pauseVideo"
                        };
                      }
                      iframe.contentWindow.postMessage(JSON.stringify(command), "*");
                    } else if (video != null) {
                      video.pause();
                    }
                  });
                }
              };
              slider.events.on('indexChanged', customizedFunction);
                  setTimeout(function() {
                    productMediaVideoControls();
                    var selectedVariantOnLoad = JSON.parse(document.querySelector(sectionMain + " .selectedVariantObject").innerHTML);
                    if (selectedVariantOnLoad != null) {
                      productSlideshows.init(selectedVariantOnLoad);
                    }
                    // productSlideshowSelector.classList.remove('media-placeholder-active');
                  }, 1000);
                }, 50);
               }
              //return slider;
              });
            }
          },
          changeVariantImage: function(slider, selectedVariant){
            if(selectedVariant && selectedVariant != undefined){
              if(selectedVariant.featured_media != null){
                var image_src = selectedVariant.featured_image.src;
                var position = (selectedVariant.featured_media.position)-1;
                var image_id = selectedVariant.featured_media.id;
                if (document.querySelector('.slides.js-slides').offsetHeight > 0) {
                  var img_trigger = document.querySelector('[data-media-id="'+image_id+'"]');
                  var tnsOuter = img_trigger.closest('#product-form').querySelector('[data-nav="'+position+'"]');
                  tnsOuter.click();
                }
                var desktopMediaWrp = document.querySelector('.product-media-desktop-only');
                if(desktopMediaWrp != null && document.querySelector('.product-media-desktop-only').offsetHeight > 0){
                  var image = desktopMediaWrp.querySelector('.single-product-image[data-media-id="'+image_id+'"]');
                  gsap.to(window, { duration: 0.1, scrollTo: {  y: image } });
                }
                console.log("image height updated");
              }
            }
          },
          init: function(selectedVariant){
            if(selectedVariant && selectedVariant != undefined){
              if(selectedVariant.featured_media != null){
                console.log(this, "init slideshow called");
                var this_sl = this;
                this.changeVariantImage(productSlideshows.sLider, selectedVariant);//this refers to productSlideshows object
                setTimeout(function(){
                 this_sl.changeVariantImage(productSlideshows.sLider, selectedVariant);//this refers to productSlideshows object
                }, 450);
              }
            }
          }
        };
        //initiate the function
        if(document.querySelector(".selectedVariantObject") !== null){
          // parses a JSON string, constructing the JavaScript value or object described by the string
          var selectedVariantOnLoad = JSON.parse(document.querySelector(".selectedVariantObject").innerHTML);

          document.addEventListener("DOMContentLoaded", function(slider) {
            //check if slider is already initialized
            var cont = document.querySelector("#product-image");
            if(cont != null){
              if(cont.querySelector(".tns-outer") == null){
                //slider is not initialized yet
                productSlideshows.setup(this);
              }
            }
            productSlideshows.init(selectedVariantOnLoad);
          });
          document.addEventListener("shopify:section:load", function(event) {
            productSlideshows.init(selectedVariantOnLoad);
          });
          document.addEventListener("shopify:section:unload", function(event) {
            productSlideshows.init(selectedVariantOnLoad);
          });
          document.addEventListener("shopify:section:reorder", function(event) {
            productSlideshows.init(selectedVariantOnLoad);
          });
        }

        document.addEventListener("shopify:section:load", function(e) {
          var target = e.target;
          if(target.classList.contains('product-section')){
          var selectedVariantOnLoad = JSON.parse(document.querySelector(".selectedVariantObject").innerHTML);
            setTimeout(function(){
             productSlideshows.init(selectedVariantOnLoad);
            }, 100);
          }
        });
        //END - slider on product page logic

        //START - close cart
        function closeCartDrawer(e){
          var $this = this,
              $target = e.target,
              $body = document.body;

          passive: true;
          var container = document.querySelector(".sidebar");
          var containerRecommended = document.querySelector(".cart-recommendations-drawer");
          if(!(container.classList[0] === e.target.classList[0]) && container.querySelector(e.target.classList[0]) == null){
            if($body.classList.contains('show-sidebar') ){
              if($target.closest(".cart-recommendations-drawer") == null){
                $body.classList.remove('show-sidebar');
                if($body.querySelector('.js-menu-toggle') != null){
                  $body.querySelector('.js-menu-toggle').classList.remove('active');
                }
              }
            }
          }
        }
        document.addEventListener('mouseup', closeCartDrawer, true);
        document.addEventListener('touchend', closeCartDrawer, true);
        //END - close cart

        //init functions
        const sidebar = document.querySelector('.js-mini-cart-contents');
        var recommendation = document.querySelector('.mini-cart-recommendations');
        const fieldset = document.querySelector('#cart-fieldset');
        const sidebarMenu = document.querySelector('.sidebar-menu');
        const qtyInput = document.querySelector('.js-quantity-field');

        //Keep cart drawer open when menu items clicked from inside container
        const keepCartOpen = () => {
          document.body.classList.add('show-sidebar');
        }
        if(fieldset != null){
          fieldset.addEventListener('click', keepCartOpen);
          qtyInput.addEventListener('click', keepCartOpen);
        }
        sidebar.addEventListener('touchend', keepCartOpen);
        sidebar.addEventListener('click', function(e){
          if(!e.target.classList.contains("js-close-cart")){
            keepCartOpen();
          }
        });
        sidebar.addEventListener('mouseup', keepCartOpen);

        if(recommendation != null) {
          recommendation.addEventListener('touchend', keepCartOpen);
          recommendation.addEventListener('click', function (e) {
            if (!e.target.classList.contains("js-close-cart")) {
              keepCartOpen();
            }
          });
          recommendation.addEventListener('mouseup', keepCartOpen);
        }

        //open cart drawer
        if(document.querySelector(".js-menu-toggle")){
          document.querySelector(".js-menu-toggle").onclick = function() {
            shopified.openCart();
          }
        }
        //Keep mobile menu open
        const keepMenuOpen = () => {
          if(!document.body.classList.contains('show-sidebar-main')) {
            document.body.classList.add('show-sidebar-main');
            document.body.classList.add('active');
            document.body.style.position = 'fixed';
            if(document.querySelector('.left-side') != null) {
             document.querySelector('.left-side').classList.remove('border-right')
            }
            console.log('Menu opened and gasp running');
          }
        }
        //close mobile menu
        const keepMenuClosed = () => {
          if(document.body.classList.contains('show-sidebar-main')) {
            document.body.classList.remove('show-sidebar-main');
            document.body.classList.remove('active');
            document.body.style.position = '';
            if(document.querySelector('.left-side') != null) {
              document.querySelector('.left-side').style.background = 'transparent';
              document.querySelector('.left-side').classList.add('border-right')
            }
            const menuOverlay = document.querySelector('.menu-popup-background');
            if(menuOverlay){
              menuOverlay.remove();
            }
            console.log('Menu closed');
          }
        }
        //create menu overlay
        const createOverlay = () => {
          var is_exists = document.querySelector('.menu-popup-background');
          if(is_exists != null){
            is_exists.remove();
          }
          const sidebarOverlay = document.createElement('div');
          sidebarOverlay.classList.add('menu-popup-background');
          document.getElementsByTagName('body')[0].appendChild(sidebarOverlay);
          console.log('Overlay created');
        }

        //when hamburger icons is clicked
        var open = document.querySelector('.open-menu-hamburger');

        if(open != null) {
          open.onclick = function(e) {
            console.log('open');
              //createOverlay();
              keepMenuOpen();
              // animateNavigtaionListParent();
            };
          }

          var mobileMenu = document.querySelector('.js-menu-toggle-mobile');
          if(mobileMenu != null) {
            mobileMenu.onclick = function(e) {
              createOverlay();
              keepMenuOpen();
              // animateNavigtaionListParent();
            };
          }

        //keep menu open when clicking inside sidebar
        if(document.querySelector('.sidebar-menu') != null) {
          document.querySelector('.sidebar-menu').onclick = function(e) {
            document.body.removeEventListener('click', closeSidebar);
            keepMenuOpen();
            //createOverlay();
            var target = e.target;
            if(target.closest('.sidebar-menu-columns') == null) {
              keepMenuClosed();
            }
          }
        }
        //close sidebar when clicked on overlay
        const closeSidebar = (e) => {
          passive: true;
          var container = document.querySelector(".sidebar-menu");
          var $body = document.body;
          if(container != null) {
            if(!(container.classList[0] === e.target.classList[0]) && container.querySelector(e.target.classList[0]) == null){
              if($body.classList.contains('show-sidebar-main')) {
                keepMenuClosed();
              }
            }
          }
        }
      //invoke event listeners
      document.addEventListener("DOMContentLoaded", function(e) {
        const mobileEl = document.querySelector('.mobile-logo-wrapper');
        passive: true;
        document.addEventListener('click', closeSidebar, true);
        if(mobileEl != null) {
          mobileEl.addEventListener('touchstart', closeSidebar, { passive: true });
          mobileEl.addEventListener('touchend', closeSidebar, { passive: true });
          mobileEl.addEventListener('touchcancel', closeSidebar, { passive: true });
          mobileEl.addEventListener('touchmove', closeSidebar, { passive: true });
        }
      });

      //START - storefront filters
      let storefrontFilter = {
        init: function() {
          var $products;
          if(document.body.getAttribute("id") == "search"){
            $products = document.querySelector("#search")
          } else {
            $products = document.querySelector(".products")
          }
          if($products != null){
            var applyBtn = document.querySelectorAll('.filter-apply-btn');
            if(applyBtn != null){
              applyBtn.forEach(function(btn,index){
                btn.onclick = function (e) {
                  var classNames = btn.closest('.collection-filter-sidebar').querySelector('#form-id').className;
                  e.preventDefault();
                  e.stopPropagation();
                  storefrontFilter.productFilter(this, classNames, $products);
                }
              });
            }
            $products.querySelectorAll(".filter-menu #form-id input").forEach(function(item, index){
              item.onchange = function(e){
                console.log(item.closest('#form-id').className , "product filter item");
                var classNames = item.closest('#form-id').className;
                e.preventDefault();
                e.stopPropagation();
                storefrontFilter.productFilter(this, classNames, $products);
              }
            });
          }
          // init sortby dropdown
          storefrontFilter.sortByFilter();
        },
        productFilter: function(self, classNames2, $products){
          var removeFilter = null;
          let filterURL = '';
            //add class
            if(self.classList.contains("activeFilter")){
              self.classList.remove("activeFilter");
            } else {
              self.classList.add("activeFilter");
            }
            //price range filter
            if($products.querySelector(".range-slider") !== null ){
              var rangeSliderContainer = $products.querySelector(".range-slider"),
                  numberSlider = rangeSliderContainer.querySelectorAll("input[type=number]"),
                  rangeSlider = rangeSliderContainer.querySelectorAll("input[type=range]");

              if(self.getAttribute("type") == "range"){
                numberSlider = rangeSliderContainer.querySelectorAll("input[type=range]");
                rangeSlider = rangeSliderContainer.querySelectorAll("input[type=number]");
              }

              var view = '';
              //for each number input set the value to the value selected
              numberSlider.forEach(function(element) {
                event.preventDefault();
                var numberVal1 = parseFloat(numberSlider[0].value),
                    numberVal2 = parseFloat(numberSlider[1].value);

                if(numberVal1 > numberVal2) {
                  var tmp = numberVal1;
                  numberSlider[0].value = numberVal2;
                  numberSlider[1].value = tmp;
                }
                rangeSlider[0].value = numberVal1;
                rangeSlider[1].value = numberVal2;
              });
            }
            //end price range filter

            if($products.querySelector(".activeFilter") !== null) {
              if(document.body.getAttribute("id") == "search"){
                const searchVal = document.querySelector(".search-term").value;
                view = searchVal;//for search page
              }
            }

            //function will read all filters input:checked
            //generate a pattern of URL to be created based on selection
            if (classNames2.includes("desktop-version-filter-form")){
              filterURL = storefrontFilter.urlWithActiveFiltersDesktop();
            }
            if (classNames2.includes("mobile-version-filter-form")){
              filterURL = storefrontFilter.urlWithActiveFiltersMobile();
            }

            console.log('filterURL', filterURL);
            let allProducts = document.querySelector(".index-home-collections-template .products > div");
            let queryEl = '', url = '';
            if(document.body.getAttribute("id") == "search") {
              url = window.location.href + filterURL;
            } else {
              var baseURL = window.location.href.split("?")[0];
              //url = baseURL + "?view=" + view + filterURL;
              url = baseURL + "?" + filterURL;
            }
            url = url.replace('#', '');
            var request = fetch(url, {
              method: "GET"
            })
            .then(response => response.text())
            .then(function(response){
              var parser = new DOMParser();
              var doc = parser.parseFromString(response, "text/html");

              if(document.body.getAttribute("id") == "search") {
                var filterHtml = doc.querySelector('#page-search .search-result-container').innerHTML;
                document.querySelector('#page-search .search-result-container').innerHTML = filterHtml;
              } else {
                //allProducts.innerHTML = response;
                var filterRowHtml = doc.querySelector('.index-home-collections-template .products .collection-page').innerHTML;
                allProducts.innerHTML = filterRowHtml;
                if(document.body.classList.contains('show-sidebar-filter')){
                 document.body.classList.remove('show-sidebar-filter');
                }
                //endless scroll when filters are selected
                if(document.querySelector('#ajaxPagination') != null){
                  var endlessScroll = new Ajaxinate({
                    container: '.products-on-page',
                    pagination: '#ajaxPagination'
                  });
                }
              }
              // Collection sidebar filter toggle
              var body = document.querySelector('body');
              var btns = document.querySelectorAll('a.collection-filter-button,.filter-by-nav-pills li a');
                if(btns != null){
                 btns.forEach(function(btn,index){
                  btn.onclick = function(e){
                    e.preventDefault();
                    document.body.classList.add('show-sidebar-filter');
                    var accs = document.querySelectorAll('.filter-items-row');
                    if(accs != null){
                      accs.forEach(function(acc,index){
                        var item = acc.querySelector('.collapse');
                        var tabTitle = acc.querySelector('.card-header a');
                        if(item != null){
                          tabTitle.setAttribute('aria-expanded',false);
                          item.classList.remove('show');
                          tabTitle.classList.add('collapsed');
                        }
                      });
                    }

                    if(btn.closest('.nav-item') != null){
                      var target = btn.dataset.target
                      if(target != undefined){
                        var tab = document.querySelector(target);
                        var tabTitle = tab.closest('.filter-items-row').querySelector('.card-header a');
                        tabTitle.click();
                      }
                    }
                  }
                });
              }

              var $products = document.querySelector(".products");

              removeFilter = $products.querySelectorAll("a[aria-label=remove]");
              removeFilter.forEach(function(item, index){
                console.log(item, "remove filter item");
                item.onclick = function(e){
                  e.preventDefault();
                  storefrontFilter.removeFilterFunction(this);
                }
              });

              var applyBtn = document.querySelectorAll('.filter-apply-btn');
              if(applyBtn != null){
                applyBtn.forEach(function(btn,index){
                  btn.onclick = function (e) {
                    var classNames = btn.closest('.collection-filter-sidebar').querySelector('#form-id').className;
                    e.preventDefault();
                    e.stopPropagation();
                    storefrontFilter.productFilter(this, classNames, $products);
                  }
                });
              }
              $products.querySelectorAll(".filter-menu #form-id input").forEach(function(item, index){
                item.onchange = function(e){
                  console.log(item.closest('#form-id').className , "product filter item");
                  var classNames = item.closest('#form-id').className;
                  e.preventDefault();
                  e.stopPropagation();
                  storefrontFilter.productFilter(this, classNames, $products);
                }
              });
              // init sortby dropdown
              storefrontFilter.sortByFilter();
            })
            .then(() => {
              console.log('Init slim select');
              const selects = document.querySelectorAll(`select.select2:not([data-ssid])`);
              selects.forEach((selectElement) => {
                let specialSelect = selectElement;
                new SlimSelect({
                  select: specialSelect,
                  closeOnSelect: true,
                  hideSelectedOption: false,
                  showSearch: false,
                  onChange: (e) => {
                   var val = e.value;
                    console.log(val);
                  }
                });
              });
              //filter sidebar for collection page
              var script = document.querySelectorAll('#filter-sidebar')
              for (var n = 0; n < script.length; n++){
                eval(script[n].innerHTML)
              }
              //shopify default sortby
              var script2 = document.querySelectorAll('#for-sort-by-options');
              for (var n = 0; n < script2.length; n++){
                //The eval() function evaluates JS code represented as a string and returns its completion value.
                eval(script2[n].innerHTML);
                console.log(eval(script2[n].innerHTML));
              }
            })
            .catch((err) => {
              console.log('Rejected', err);
            });
          },
          //adding filters
          urlWithActiveFilters: function(){
            var $products = document.querySelector(".products");
            let af = $products.querySelectorAll("#form-id input:checked");
            let url = '';//set to blank

            //for price filter
            var pf = $products.querySelectorAll("#form-id input[type=number]");
            pf.forEach(function(item, index){
              url += '&' + item.getAttribute('name') + '=' + encodeURIComponent(item.value);
            });
            //for price filter

            //for active filters
            af.forEach(function(item, index){
              url += '&' + item.getAttribute('name') + '=' + encodeURIComponent(item.value);
            });
            //end for active filters
            url = url.replaceAll(' ', '+');
            return url;
          },
          //desktop filters
          urlWithActiveFiltersDesktop: function(){
            var $products = document.querySelector(".products");
            let af = $products.querySelectorAll("#form-id.desktop-version-filter-form input:checked");
            let url = '';//set to blank

            //for price filter
            var pf = $products.querySelectorAll("#form-id input[type=number]");
            pf.forEach(function(item, index){
              url += '&' + item.getAttribute('name') + '=' + encodeURIComponent(item.value);
            });
            //for price filter

            //for active filters
            af.forEach(function(item, index){
              url += '&' + item.getAttribute('name') + '=' + encodeURIComponent(item.value);
            });
            //end for active filters
            url = url.replaceAll(' ', '+');
            return url;
          },
          //mobile filters
          urlWithActiveFiltersMobile: function(){
            var $products = document.querySelector(".products");
            let af = $products.querySelectorAll("#form-id.mobile-version-filter-form input:checked");
            let url = '';//set to blank

            //for price filter
            var pf = $products.querySelectorAll("#form-id input[type=number]");
            pf.forEach(function(item, index){
              url += '&' + item.getAttribute('name') + '=' + encodeURIComponent(item.value);
            });
            //for price filter

            //for active filters
            af.forEach(function(item, index){
              url += '&' + item.getAttribute('name') + '=' + encodeURIComponent(item.value);
            });
            //end for active filters
            url = url.replaceAll(' ', '+');
            return url;
          },
          //clear filter
          removeFilterFunction: function(self){
          console.log(self);
            let filterRemoveURL = self.getAttribute('href');
            console.log(filterRemoveURL);
            let allProducts = document.querySelector(".index-home-collections-template .products > div");

            var request = fetch(filterRemoveURL, {
              method: "GET"
            })
            .then(response => response.text())
            .then(function(response){
              console.log(response);

              if(document.body.getAttribute("id") == "search") {
                document.body.innerHTML = response;
              } else {
                allProducts.innerHTML = response;
              }

              var applyBtn = document.querySelectorAll('.filter-apply-btn');
              if(applyBtn != null){
                applyBtn.forEach(function(btn,index){
                  btn.onclick = function (e) {
                    var classNames = btn.closest('.collection-filter-sidebar').querySelector('#form-id').className;
                    e.preventDefault();
                    e.stopPropagation();
                    storefrontFilter.productFilter(this, classNames);
                  }
                });
              }
              $products.querySelectorAll(".filter-menu #form-id input").forEach(function(item, index){
                item.onchange = function(e){
                  console.log(item.closest('#form-id').className , "product filter item");
                  var classNames = item.closest('#form-id').className;
                  e.preventDefault();
                  e.stopPropagation();
                  storefrontFilter.productFilter(this, classNames);
                }
              });
            })
            .then(() => {
              const loadmoreWrapper = document.querySelector(".load-more-wrapper")
              if(loadmoreWrapper){
                loadmoreWrapper.style.display = "none";
              }
            }).catch((err) => {
              console.log(err);
            });
          },
          sortByFilter: function(){
            console.log('filters loaded');
            var sortBy = document.querySelector('.filter-sort-by-top select.slct');
            if(sortBy != null) {
              sortBy.addEventListener('change', function(e) {
                var filterURL = storefrontFilter.urlWithActiveFiltersMobile();
                var value = e.currentTarget.value;
                console.log(value);
                if(filterURL != ''){
                  var filterURLSearch = filterURL+'&sort_by='+value;
                  location.search = new URLSearchParams(filterURLSearch).toString();
                } else {
                  Shopify.queryParams.sort_by = value;
                  location.search = new URLSearchParams(Shopify.queryParams).toString();
                }
              });
            }

            var rangeSliderContainers = document.querySelectorAll(".range-slider");
            if(rangeSliderContainers != null){
              rangeSliderContainers.forEach(function(rangeSliderContainer,index){
              var
                rangeSlider = rangeSliderContainer.querySelectorAll("input[type=range]"),
                numberSlider = rangeSliderContainer.querySelectorAll("input[type=number]");

              rangeSlider.forEach(function(element) {
                element.oninput = function(event) {
                  event.preventDefault();
                  var slideVal1 = parseFloat(rangeSlider[0].value),
                    	slideVal2 = parseFloat(rangeSlider[1].value);

                  if (slideVal1 > slideVal2) {
                    // Array destructuring designed to unpack values from arrays into distinct variables.
                    //reassigning values 1 to 2 and 2 to 1
            				[slideVal1, slideVal2] = [slideVal2, slideVal1];
                  }

                  numberSlider[0].value = slideVal1;
                  numberSlider[1].value = slideVal2;
                }
              });
             });
            }

            // open filter sidebar when clicked on pills tab
            var body = document.querySelector('body');
            var btns = document.querySelectorAll('a.collection-filter-button,.filter-by-nav-pills li a');
              if(btns != null){
               btns.forEach(function(btn,index){
                btn.onclick = function(e){
                  e.preventDefault();
                  document.body.classList.add('show-sidebar-filter');
                  var accs = document.querySelectorAll('.filter-items-row');
                  if(accs != null){
                    accs.forEach(function(acc,index){
                      var item = acc.querySelector('.collapse');
                      var tabTitle = acc.querySelector('.card-header a');
                      if(item != null){
                        tabTitle.setAttribute('aria-expanded',false);
                        item.classList.remove('show');
                        tabTitle.classList.add('collapsed');
                      }
                    });
                  }
                  if(btn.closest('.nav-item') != null){
                    var target = btn.dataset.target
                    if(target != undefined){
                      var tab = document.querySelector(target);
                      var tabTitle = tab.closest('.filter-items-row').querySelector('.card-header a');
                      tabTitle.click();
                    }
                  }
                }
              });
            }

           //close mobile filter menu
            const keepFilterClosed = () => {
              if(document.body.classList.contains('show-sidebar-filter')) {
                document.body.classList.remove('show-sidebar-filter');
                document.body.classList.remove('active');
                const menuOverlay = document.querySelector('.menu-popup-background');
                if(menuOverlay){
                  menuOverlay.remove();
                }
              }
            }

            // close filter sidebar when clicked on icon or overlay
            var $body = document.body;
            $body.onclick = function(e) {
             var target = e.target;
              if(target.classList.contains('collection-filter-close') || target.closest('.collection-filter-close') ){
                keepFilterClosed();
              }
              if( !(target.closest('.filter-by-nav-pills')) && !(target.closest('.filter-icon')) && !(target.classList.contains('.filter-icon')) && target.closest('.collection-filter-sidebar') == null && $body.classList.contains('show-sidebar-filter')) {
                 keepFilterClosed();
              }
            }
          }
        }
        document.addEventListener("DOMContentLoaded", function() {
         //end adding filters
          storefrontFilter.init();
        });
        document.addEventListener("shopify:section:load", function() {
          storefrontFilter.init();
        });
        //END - storefront filters

        //START - product media with videos
        let productVideos = {
          //For each video player, create custom thumbnail or
          //use Youtube max resolution default thumbnail and create iframe video.
           getVideos: function() {
            var v = document.getElementsByClassName("youtube-player");
            for (var n = 0; n < v.length; n++) {
              var p = document.createElement("div");
              var id = v[n].getAttribute("data-id");

              var placeholder = v[n].hasAttribute("data-thumbnail")
                  ? v[n].getAttribute("data-thumbnail")
                  : "";

              if (placeholder.length) p.innerHTML = productVideos.createCustomThumbail(placeholder);
              else p.innerHTML = productVideos.createThumbail(id);

              v[n].appendChild(p);
              p.addEventListener("click", function () {
                  var parent = this.parentNode;
                  productVideos.createIframe(parent, parent.getAttribute("data-id"));
              });
            }
          },
         //Create custom thumbnail from data-attribute provided url
         //@param {string} url
         //@return {string} The HTML containing the <img> tag
         createCustomThumbail: function(url) {
            return (
              '<img loading="lazy" class="youtube-thumbnail failed tns-complete" src="' +
              url +
              '" alt="Video Preview" /><span class="play-poster-button"><div class="youtube-play-btn"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" fill="none" viewBox="0 0 10 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"></path></svg></div></span>'
            );
          },
          //Get Youtube default max resolution thumbnail
          //@param {string} id The Youtube video id
          //@return {string} The HTML containing the <img> tag
          createThumbail: function(id) {
            return (
              '<img loading="lazy" class="youtube-thumbnail" src="//i.ytimg.com/vi_webp/' +
              id +
              '/maxresdefault.webp" alt="Video Preview"><div class="youtube-play-btn"></div>'
            );
          },
          //Create and load iframe in Youtube container
          createIframe: function(v, id) {
            var iframe = document.createElement("iframe");
            console.log(v);
            iframe.setAttribute(
                "src",
                "//www.youtube.com/embed/" +
                    id +
                    "?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0"
            );
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("class", "youtube-iframe");
            v.firstChild.replaceWith(iframe);
          },
          init: function(){
            productVideos.getVideos();
          }
        }
        //invoke the function
        document.addEventListener("DOMContentLoaded", function() {
          productVideos.init();
        });
        //END - product media with videos

        //GET - the selected variant data of a product
        if(document.querySelector(".selectedVariantObject") !== null) {
          //parses a JSON string, constructing the JavaScript value or object described by the string
          var _selectedVariant = JSON.parse(document.querySelector(".selectedVariantObject").innerHTML);
          console.log('Show selected variant', _selectedVariant);
        }

        //change conditions when stock levels are reached
        //control subscription logic on PDP and collection page LAYOUT

        const btnRow2 = document.body.querySelector('.js-btn-col-two');
        const btnRow3 = document.body.querySelector('.js-btn-col-three');

        let state = {
          changeMaxQuantity: function(){
            if(document.querySelectorAll('#product').length > 0){
             if(document.querySelectorAll('.quantity-that-has-already-been-added').length > 1){
               var form = document.querySelector('.js-quantity-field-pdp').closest('form');
               _selectedVariant = productForm.getActiveVariant(form);
             }
            if(_selectedVariant != null) {
              var valueSet = false;
              document.querySelectorAll('.quantity-selector-stocks .quantity-that-has-already-been-added').forEach(function(self){
                console.log('this', self.dataset.id);
                if(self.dataset.id == document.querySelector('#js-product-id').value) {
                  console.log('self2', self.dataset.id);
                  var quantity = parseInt(self.dataset.quantity);
                  var quantitySelectorValue = parseInt(self.dataset.maxQuantity);
                  console.log('quantitySelectorValue', self.dataset);
                  var setValue = quantitySelectorValue - quantity;

                  var inventorypolicy = self.dataset.inventorypolicy;

                  if(_selectedVariant.inventory_management == 'shopify') {
                    if(inventorypolicy == 'continue'){
                      document.querySelector('.js-quantity-field-pdp').setAttribute('max', 100000);
                    } else {
                      document.querySelector('.js-quantity-field-pdp').setAttribute('max', setValue);//should be quantitySelectorValue?
                    }
                  } else {
                    document.querySelector('.js-quantity-field-pdp').setAttribute('max', 100000);
                  }
                  valueSet = true;

                  if(_selectedVariant != null) {
                    if(_selectedVariant.inventory_management == 'shopify' || _selectedVariant.available == true) {
                      const allBtns = document.querySelectorAll('.add-to-cart-button');
                        if(parseInt(setValue) <= 0){
                          if(_selectedVariant.inventory_management == null && _selectedVariant.available == true) {
                            document.querySelector('.js-quantity-field-pdp').value = 1;
                            allBtns.forEach(function(item) {
                              item.removeAttribute('disabled');
                              if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').removeAttribute('disabled', 'disabled');}
                            });
                            document.querySelector('.js-quantity-field-pdp').removeAttribute('disabled');
                            document.querySelector('.js-quantity-button-pdp.plus.js-plus').removeAttribute('disabled');
                            if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').removeAttribute('disabled', 'disabled');}
                          } else {
                            document.querySelector('.js-quantity-field-pdp').value = 1;
                            allBtns.forEach(function(item) {
                             item.setAttribute('disabled', 'disabled');
                             if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').setAttribute('disabled', 'disabled');}
                            });
                            document.querySelector('.js-quantity-field-pdp').setAttribute('disabled', 'disabled');
                            document.querySelector('.js-quantity-button-pdp.plus.js-plus').setAttribute('disabled', 'disabled');
                            if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').setAttribute('disabled', 'disabled');}
                          }
                        }
                        else {
                          document.querySelector('.js-quantity-field-pdp').value = 1;
                          allBtns.forEach(function(item) {
                            item.removeAttribute('disabled');
                            if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').removeAttribute('disabled', 'disabled');}
                          });
                          document.querySelector('.js-quantity-field-pdp').removeAttribute('disabled');
                          document.querySelector('.js-quantity-button-pdp.plus.js-plus').removeAttribute('disabled');
                        }
                        console.log(quantitySelectorValue);
                      } else {
                        return;
                      }
                    }
                  }
                });
              }
            }
          },
          changeAddedQuantity: function(variantId, quantity){
            console.log('changeAddedQuantity ID and QTY as a method', variantId, quantity);
            if(document.querySelectorAll('#product').length > 0){
              document.querySelectorAll('.quantity-selector-stocks .quantity-that-has-already-been-added').forEach(function(self){
                if(self.dataset.id == variantId){
                  self.dataset.quantity = quantity;
                }
              });
            }
          },
          changeCollectionPage: function(){
            // console.log('testing changeCollectionPage function as a method');
            // if(document.querySelectorAll('.atom-theme').length > 0){
              if(document.querySelectorAll('.collection-toggle').length > 0){
                document.querySelectorAll('.collection-toggle').forEach(function(self){
                  var self2Ref = self.querySelector('.add-to-cart-form .js-variant-id');
                  if(self2Ref != null){
                    var colVariantId = parseInt(self2Ref.value);
                    var colVariantQty = parseInt(self2Ref.getAttribute('data-inventory-quantity'));
                    var colVariantInv = parseInt(self2Ref.getAttribute('data-inventory-tracking'));
                    var colVariantPolicy = parseInt(self2Ref.getAttribute('data-inventory-policy'));
                    var colVariantAvailable = parseInt(self2Ref.getAttribute('data-available'));
                    var variantQty = 0;

                    if(document.querySelector('#cart-fieldset .cart-items .line-item.bravo_' + colVariantId + ' .update_span .js-quantity-field')) {
                      variantQty = document.querySelector('#cart-fieldset .cart-items .line-item.bravo_' + colVariantId + ' .update_span .js-quantity-field').value;
                    }
                    //if variantQty is greater or equal to the inventory qty and is tracked
                    if(variantQty >= colVariantQty && colVariantInv){
                      self.querySelector('.add-to-cart-button').setAttribute('disabled', 'disabled');
                      // if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').setAttribute('disabled', 'disabled');}
                    }
                    else {
                      self.querySelector('.add-to-cart-button').removeAttribute('disabled');
                      // if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').removeAttribute('disabled', 'disabled');}
                    }
                    //if the product is not availabe, disable the quick add btn
                    if(colVariantAvailable == 0) {
                      self.querySelector('.add-to-cart-button').setAttribute('disabled', 'disabled');
                      // if(document.querySelector('.js-menu-add-btn') != null) {document.querySelector('.js-menu-add-btn').setAttribute('disabled', 'disabled');}
                    }
                  }
                });
              }
            // }
          },
          changeProductLayout: function(btn1, btn2) {
            //change row to 2
            if(btn1 != null){
              btn1.addEventListener('click', function(e) {
                e.preventDefault();
                var collectionWrapper = document.querySelectorAll('.products-on-page > .collection-toggle');
                collectionWrapper.forEach(function(item) {
                  item.classList.add('col-md-6');
                  item.classList.add('col-lg-6');
                  item.classList.remove('col-md-4');
                  item.classList.remove('col-lg-4');
                });
                btnRow2.classList.add('is-active');
                btnRow3.classList.remove('is-active');
              });
            }
            //change row to 3
            if(btn2 != null) {
              btn2.addEventListener('click', function(e) {
                e.preventDefault();
                var collectionWrapper = document.querySelectorAll('.products-on-page > .collection-toggle');
                collectionWrapper.forEach(function(item) {
                  item.classList.add('col-md-4');
                  item.classList.add('col-lg-4');
                  item.classList.remove('col-md-6');
                  item.classList.remove('col-lg-6');
                });
                btnRow3.classList.add('is-active');
                btnRow2.classList.remove('is-active');
              });
            }
          },
          subscriptionSelected2: function(cartItems2) {
            var cartItems2 = cartItems2;
            var variantId = document.querySelector('#js-product-id').value;
            if(document.querySelectorAll('#product').length > 0 && cartItems2){
              var currentVariantIsAdded = 0;
              var selectedValue = null;
              //if items exisit
              if (cartItems2.length > 0) {
                var i = 0;
                for (i = 0; i < cartItems2.length; i++) {
                  if (cartItems2[i].id == variantId){
                    //if selling plan exsists
                    if(cartItems2[i].selling_plan_allocation != undefined) {
                      var addedSelectedId = cartItems2[i].selling_plan_allocation.selling_plan.id;//selling plan id
                      var obj = document.querySelector('.reccuring-option').value;//select element value
                      //if selling id == selement element value, change the val of
                      //subscription product to 1, otherwise set the max max inventory to 1
                      if(parseInt(addedSelectedId) == parseInt(obj)){
                        var currentVariantIsAdded = 1;
                      }
                      else {
                        document.querySelector('.js-quantity-field-pdp').setAttribute('max', 1);
                      }
                    }
                  }
                }
              }
              //if current variant on PDP is in the cart disable elements
              //otherwise, enable elements to add item to cart
              if(currentVariantIsAdded){
                state.disableAddtoCartButton();
              }
              else {
                state.enableAddtoCartSubButton();
              }
            }
          },
          disableAddtoCartButton: function(){
            if(document.querySelector('.js-quantity-field-pdp') && document.querySelector('.add-to-cart-button') && document.querySelector('.js-quantity-field-pdp') && document.querySelector('.js-quantity-button-pdp.plus.js-plus')) {
              document.querySelector('.js-quantity-field-pdp').value = 1;
              //add to cart btn
              const addBtn = document.querySelectorAll('.add-to-cart-button');
              addBtn.forEach(element => {
                element.setAttribute('disabled', 'disabled');
              });
              document.querySelector('.js-quantity-field-pdp').setAttribute('disabled', 'disabled');
              document.querySelector('.js-quantity-button-pdp.plus.js-plus').setAttribute('disabled', 'disabled');
              //sticky btn
              if(document.querySelector('.sticky-add-to-cart-button')) {
                document.querySelector('.sticky-add-to-cart-button').setAttribute('disabled', 'disabled');
              }
            }
          },
          enableAddtoCartSubButton: function(){
            var checked = document.querySelector('.spg-radio-input');
            if(checked && checked.checked && document.querySelector('.js-quantity-field-pdp') && document.querySelector('.add-to-cart-button') && document.querySelector('.js-quantity-field-pdp') && document.querySelector('.js-quantity-button-pdp.plus.js-plus')){
              document.querySelector('.js-quantity-field-pdp').value = 1;
              //add to cart btn
              const addBtn = document.querySelectorAll('.add-to-cart-button');
              addBtn.forEach(element => {
                element.removeAttribute('disabled');
              });
            }
          },
          subscriptionSelected: function(cartItems2){
          var cartItems2 = cartItems2;
           var checked = document.querySelector('.spg-radio-input');
            if(checked && checked.checked){
              setTimeout(function(){
                state.subscriptionSelected2(cartItems2);//change subscription logic on product page
              }, 100);
            }
          },
          getTheCartContent: function(){
            fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
              state.subscriptionSelected(data.items);
            });
          },
          baseMaxQtyFunction: function(){
            const recOption = document.querySelector('.reccuring-option');
            if(recOption != null){
              recOption.addEventListener('change', function(){
                state.getTheCartContent();
              });
            }
            //Fetch getTheCartContent data if subscription option is changed and checked
            if(document.querySelector('.spg-radio-input') != null){
             document.querySelector('.spg-radio-input').addEventListener('change', function(){
              var checked = document.querySelector('.spg-radio-input');
                if(checked.checked){
                  state.getTheCartContent();
                }
              });
            }
            //Change max qty if one time option is changed and checked
            //using setTimeout
            if(document.querySelector('#loop-one-time-purchase') != null){
              document.querySelector('#loop-one-time-purchase').addEventListener('change', function(){
                var checked = document.querySelector('#loop-one-time-purchase');
                if(checked.checked){
                  setTimeout(function(){
                    state.changeMaxQuantity();
                  }, 100);
                }
              });
            }
            //Change max qty if one time option is checked
            var checked = document.querySelector('#loop-one-time-purchase');
            if(checked && checked.checked){
              setTimeout(function(){
                state.changeMaxQuantity();
              }, 100);
            }
          },
          init: function(){
            state.changeMaxQuantity();
            state.changeCollectionPage();
            state.changeProductLayout(btnRow2, btnRow3);
            state.baseMaxQtyFunction();
          }
        }
        //initiate the functions
        state.init();
        state.getTheCartContent();

        //initiate when shopify section changes
        document.addEventListener("shopify:section:load", function() {
          shopified.init();
          productSlideshows.setup();
          productForm.init();
          quantityPickerPdp.init();
          //remove sizinf modal in theme editor change
          var sizingPopupOverlay = document.querySelector('.modal-backdrop');
          if(sizingPopupOverlay != null){
            sizingPopupOverlay.remove();
          }
        });
        document.addEventListener("shopify:section:unload", function() {
          productSlideshows.setup();
        });
        document.addEventListener("shopify:section:reorder", function() {
          productSlideshows.setup();
        });
        window.addEventListener("resize", function() {
          productSlideshows.setup();
        });
       // product media gallery videos
       function productMediaVideoControls(e) {
          var videosWrp = document.querySelectorAll(
            ".external-video-container,.video-container"
          );
          if (videosWrp.length > 0) {
            videosWrp.forEach(function (videoWrp) {
              //console.log('videoWrp', videoWrp);
              var controls = videoWrp.querySelectorAll(
                ".video-controls-btn .video-control"
              );
              if (controls.length > 0) {
                controls.forEach(function (control) {
                  control.onclick = function () {
                    var command;
                    var iframe = videoWrp.querySelector("iframe");
                    var video = videoWrp.querySelector("video");
                    console.log(iframe);
                    if (control.classList.contains("video-play")) {
                      control.classList.add("hidden");
                      if (iframe != null) {
                        if (iframe.classList.contains("js-vimeo")) {
                          command = {
                            method: "play",
                            value: "true",
                          };
                        }
                        if (iframe.classList.contains("js-youtube")) {
                          command = {
                            event: "command",
                            func: "playVideo",
                          };
                        }
                        iframe.contentWindow.postMessage(
                          JSON.stringify(command),
                          "*"
                        );
                      } else if (video != null) {
                        video.play();
                      }
                    }
                    if (control.classList.contains("video-pause")) {
                      control.classList.add("hidden");
                      if (iframe != null) {
                        if (iframe.classList.contains("js-vimeo")) {
                          command = {
                            method: "pause",
                            value: "true",
                          };
                        }
                        if (iframe.classList.contains("js-youtube")) {
                          command = {
                            event: "command",
                            func: "pauseVideo",
                          };
                        }
                        iframe.contentWindow.postMessage(
                          JSON.stringify(command),
                          "*"
                        );
                      } else if (video != null) {
                        video.pause();
                      }
                    }
                    controls.forEach(function (controlC) {
                      if (control != controlC) {
                        controlC.classList.remove("hidden");
                      }
                    });
                    // others pause
                    videosWrp.forEach(function (videoWrpCurrent) {
                      if (videoWrpCurrent != videoWrp) {
                        var controlsCurrent = videoWrpCurrent.querySelectorAll(
                          ".video-controls-btn .video-control"
                        );
                        if (controlsCurrent.length > 0) {
                          controlsCurrent.forEach(function (controlCurrent) {
                            if (controlCurrent.classList.contains("video-play")) {
                              controlCurrent.classList.remove("hidden");
                            } else {
                              controlCurrent.classList.add("hidden");
                            }
                          });
                        }
                        var iframe = videoWrpCurrent.querySelector("iframe");
                        var video = videoWrpCurrent.querySelector("video");
                        if (iframe != null) {
                          if (iframe.classList.contains("js-vimeo")) {
                            command = {
                              method: "pause",
                              value: "true",
                            };
                          }
                          if (iframe.classList.contains("js-youtube")) {
                            command = {
                              event: "command",
                              func: "pauseVideo",
                            };
                          }
                          iframe.contentWindow.postMessage(
                            JSON.stringify(command),
                            "*"
                          );
                        } else if (video != null) {
                          video.pause();
                        }
                      }
                    });
                  };
                });
              }
            });
          }
        }
        document.addEventListener("DOMContentLoaded", function (e) {
          productMediaVideoControls(e);
        });
        document.addEventListener("shopify:section:load", function (e) {
          productMediaVideoControls(e);
        });
        document.addEventListener("shopify:section:unload", function (e) {
          productMediaVideoControls(e);
        });
        document.addEventListener("shopify:section:reorder", function (e) {
          productMediaVideoControls(e);
        });
      })();
      //END - All code to execute as soon as the script loads

      //START - serialize form data
      function serialize(form){
      let requestArray = [];
      form.querySelectorAll('[name]').forEach((elem) => {
        if(elem.value != ""){
          if(elem.getAttribute("type") == "radio"){
            //in case of radio buttons get the checked value only
            if(elem.checked === true){
              requestArray.push({'name': elem.name, 'value': elem.value});
            }
          } else {
            requestArray.push({'name': elem.name, 'value': elem.value});
          }
        }
      });
      if(requestArray.length > 0)
        return requestArray;
      else
        return false;
      }
      //END - serialize form data

      // trigger DOMContentLoaded
      function scriptsDone () {
        var DOMContentLoadedEvent = document.createEvent('Event')
        DOMContentLoadedEvent.initEvent('DOMContentLoaded', true, true)
        // document.dispatchEvent(DOMContentLoadedEvent)//conflict with gsap
      }
      /* helpers */
      // runs an array of async functions in sequential order
      function seq (arr, callback, index) {
        // first call, without an index
        if (typeof index === 'undefined') {
          index = 0
        }

        arr[index](function () {
          index++
          if (index === arr.length) {
            callback()
          } else {
            seq(arr, callback, index)
          }
        })
      }

      function runScripts ($container) {
        //get scripts tags from a node
        var $scripts = $container.querySelectorAll('script')
        var runList = []
        var typeAttr

        [].forEach.call($scripts, function ($script) {
          typeAttr = $script.getAttribute('type')

          //only run script tags without the type attribute
          //or with a javascript mime attribute value
          if (!typeAttr || runScriptTypes.indexOf(typeAttr) !== -1) {
            runList.push(function (callback) {
              insertScript($script, callback)
            })
          }
        })
        //insert the script tags sequentially
        //to preserve execution order
        seq(runList, scriptsDone)
      }
      /* script runner */
      function insertScript ($script, callback) {
        var s = document.createElement('script')
        s.type = 'text/javascript'
        if ($script.src) {
          s.onload = callback
          s.onerror = callback
          s.src = $script.src
        } else {
          s.textContent = $script.innerText
        }

        // re-insert the script tag so it executes.
        document.head.appendChild(s)

        // clean-up
        $script.parentNode.removeChild($script)

        // run the callback immediately for inline scripts
        if (!$script.src) {
          callback()
        }
      }
      // https://html.spec.whatwg.org/multipage/scripting.html
      var runScriptTypes = [
        'application/javascript',
        'application/ecmascript',
        'application/x-ecmascript',
        'application/x-javascript',
        'text/ecmascript',
        'text/javascript',
        'text/javascript1.0',
        'text/javascript1.1',
        'text/javascript1.2',
        'text/javascript1.3',
        'text/javascript1.4',
        'text/javascript1.5',
        'text/jscript',
        'text/livescript',
        'text/x-ecmascript',
        'text/x-javascript'
      ]
